import * as React from 'react';
import * as PIXI from 'pixi.js';
import { connect } from 'react-redux';
import AppHistory from '__common/modules/history';
import V3Nav from '../components/V3Nav';
import V3Breadcrumb from '../components/V3Breadcrumb';
import V3AutosaveIndicator from '../components/V3AutosaveIndicator';
import V3AvatarMenu from '../components/V3AvatarMenu';
import V3LeftPanel from '../components/V3LeftPanel';
import V3Button from '../components/V3Button';
import ModuleSection from './leftPanel/ModuleSection';
import LocationSection from './leftPanel/LocationSection';
import AdvancedSection from './leftPanel/AdvancedSection';
import PanelsEditor from '__editor/panelsEditor/panelsEditor';
import BomPanel from './rightPanel/BomPanel';
import reduxStore, { dispatch as reduxDispatch } from '__common/store';
import { SET_DRAW_RUBBER_BAND, SET_REMOVE_RUBBER_BAND, RESET_RUBBERBAND_STATE } from '__editor/panelsEditor/actions';
import { SHOW_CURSOR, HIDE_CURSOR, FLIP_CURSOR, SET_PORTRAIT_CURSOR, SET_YELLOW_CURSOR } from '__editor/panelsEditor/components/cursor/cursorActions';
import { UNBLOCK_CREATING_PANEL, BLOCK_CREATING_PANEL, REMOVE_PANELS, UPDATE_PANELS, RESTORE_PANELS_FOR_NO_MOVEMENT } from '__editor/panelsEditor/components/panels/panelsActions';
import nextUid from '__common/calculations/nextUid';
import { MOVE_MAP_MODE_ENABLE, MOVE_MAP_MODE_DISABLE, MOVE_ARRAY_MODE_DISABLE, ENABLE_ARRAY_NUMBER_FEATURE, DISABLE_ARRAY_NUMBER_FEATURE, TOGGLE_ATTACHMENTS_DISABLE, DISABLE_BAYS_CONTAINER, SET_METERS_PER_PIXEL } from '__editor/panelsEditor/components/background/backgroundActions';
import { LITE_UNDO_HISTORY, LITE_REDO_HISTORY, LITE_SEED_HISTORY, LITE_RESTORE_HISTORY } from 'v3/workspace/history/liteHistoryActions';
import { LOAD_PANELS_FROM_HISTORY, RESTORE_PANELS_COLLISIONS_BOUNDS } from '__editor/panelsEditor/components/panels/panelsActions';
import { resetRTree } from '__editor/panelsEditor/components/panels/panelsCollisions';
import { deleteAllPanels } from '__editor/panelsEditor/components/panels/utils/panelsManagment';
import { savePanelsEditor } from '__editor/panelsEditor/components/panels/panels';
import { getPanelsContainer } from '__editor/panelsEditor/components/panels/utils/panelsContainer';
import { DISABLE_RUBBER_BAND } from '__editor/panelsEditor/components/rubberBand/rubberBandActions';
import { TURN_ON_MEASUREMENT_TOOL, TURN_OFF_MEASUREMENT_TOOL } from '__editor/googleMapsRoofsSelector/components/measurementTool/measurementToolActions';
import { CHANGE_PANELS_SIZES } from '__editor/panelsEditor/components/settings/settingsActions';
import { CLEAR_OBSTRUCTIONS, REMOVE_OBSTRUCTION } from '__editor/panelsEditor/components/obstructions/ObstructionsActions';
import { RESET_DRAWING_MANAGER } from '__editor/googleMapsRoofsSelector/components/drawingManager/drawingManagerActions';
import { OPEN_CONFIRM_CLEAR_ARRAYS_MODAL } from 'projectDesign/components/confirmClearArraysModal/confirmClearArraysModalActions';
import { newRoofOverlaping } from '__editor/components/roofsSelector/components/roofsSelectorDrawingManager/roofsSelectorDrawingManager';
import { getRenderer } from '__editor/panelsEditor/components/renderer/renderer';
import { getStage } from '__editor/panelsEditor/components/stage/stage';
import { zoom as pixiZoom } from '__editor/panelsEditor/components/stage/zoom';
import { UPDATE_LITE_PROJECT_REQUEST } from 'v3/dashboard/liteProjectActions';
import { clearBomEditCache } from 'v3/bomPage/liteBomEdits';
import { MARK_LITE_DIRTY } from 'app/appActions';
import { BOM_RESET } from 'actions';
import { state } from '__common/store';
import { products, isSolarMount, isNxtHorizon, isCommercialProduct, isSMFlushOrTiltOrTiltPR, isSMAscenderFlush } from '__common/constants/products';
import { getLiteProductLabel } from 'app/components/HeaderComponent/utils/getProducts';
import { MidEndClampChoice } from 'projectDesign/components/projectConfiguration/utils/constants';
import { MAP_TYPE } from '__common/constants/map';
import { showSuccessAlert } from '__common/modules/alerts';
import config from 'config';
import {
  buildUserProfilePayload,
  SAVE_USER_PROFILE_REQUEST,
  UPDATE_USER_PROFILE_REQUEST,
  FETCH_USER_PROFILES_REQUEST,
  FETCH_PROJECT_VARIABLES_REQUEST,
  FETCH_MFG_MODELS_REQUEST,
  SET_PROJECT_OPTION,
  SET_LOCATION,
  SET_MAP_CENTER,
  SET_MAP_ZOOM,
} from 'actions';
import { ROOF_PITCH, getDefaultRoofPitchValue } from '__editor/panelsEditor/components/tiltedRoof/tiltedRoof';
import { isValidCoordinates } from '__editor/panelsEditor/components/background/utils/isValidCoordinates';

// Original UBuilder map + drawing system — reused, not reimplemented.
import { centerMapOnRoofs, googleMapRelocation, initializeMap, removeMap, turnGoogleMapsOffMapMoveControls, turnGoogleMapsOnMapMoveControls } from '__editor/googleMapsRoofsSelector/components/map/map';
import { clearEvents as clearLegacyStageEvents } from '__editor/googleMapsRoofsSelector/googleMapsRoofsSelectorHelper';
import { initPixi, clearPixiLayer, getPixiLayer } from '__editor/googleMapsRoofsSelector/components/stage/stage';
import {
  renderAdanvaceRoofSelecting,
  shiftDown,
  shiftUp,
  clearGoogleAdvanceRoofSelecting,
} from '__editor/googleMapsRoofsSelector/components/advanceRoofSelecting/advanceRoofSelecting';
import { addNewRoofArea, createRoofArea, deleteAllGoogleRoofs, getAllGoogleRoofObject, setRoofDimensions } from '__editor/googleMapsRoofsSelector/components/drawingManager/drawingManager';
import { selectRoofLeadEdge, findSouthMostEdgeIndex } from '__editor/googleMapsRoofsSelector/components/leadEdgeRoofSelector/utils/selectEdge';
import { createLeadEdgesOnMap } from '__editor/googleMapsRoofsSelector/components/leadEdgeRoofSelector/leadEdgeRoofSelector';
import { TURN_ON_ROOF_SELECTING, TURN_OFF_ROOF_SELECTING, TERMINATE_ADVANCE_ROOF_SELECTING, CLEAR_TEMP_POINT, TOGGLE_ADVANCE_ROOF_DIMENSIONS, CLEAR_BACKGROUND_REDUCER, DEACTIVE_PANELS_EDITOR, ACTIVE_PANELS_EDITOR, LOAD_ROOFS_FROM_API, SELECT_ROOF_LEAD_EDGE, SET_TILTED_ROOF } from 'actions';
import { SET_DEFAULT_MAP_ROOFS_SELECTOR, SET_BLANK_MAPS_ROOFS_SELECTOR } from '__editor/components/roofsSelector/roofsSelectorActions';
import { setShouldSkipFetZipCode } from '__editor/components/roofsSelector/components/roofsSelectorMap/roofsSelectorMap';
import { setPlaceMarker, removePlaceMarker, changeCityAndZipCode } from '__editor/googleMapsRoofsSelector/components/locationSearch/locationSearch';
import { clearLastZipCode } from '__editor/components/roofsSelector/components/roofsSelectorMap/roofsSelectorMapEpic';
import { terminateKeyboard, initKeyboard } from '__editor/panelsEditor/keyboardConfg';
import { getRoofEdgesCoords } from '__editor/panelsEditor/components/roofEdges/roofEdgesCollisions';
import { draw_on_area } from '__editor/panelsEditor/components/panels/utils/draw_on_area';
import { createPanel } from '__editor/panelsEditor/components/panels/utils/panelsManagment';
import { REQUEST_ADD_PANELS } from '__editor/panelsEditor/components/panels/panelsActions';
import { isGFT, isULA, isAscender, isRMFamily } from '__common/constants/products';
import { drawGftPanelsInTables } from '__editor/panelsEditor/components/panels/utils/drawGftPanelsInTables';
import { drawUlaPanelsInTables } from '__editor/panelsEditor/components/panels/utils/drawUlaPanelsInTables';
import { drawAscenderPanelsInTables } from '__editor/panelsEditor/components/panels/utils/drawAscenderPanelsInTables';
import { draw_double_panels_on_area } from '__editor/panelsEditor/components/panels/utils/draw_double_panels_on_area';
import { UserProfile } from '../../../../decls/bom/userProfile';
import {
  ADD_PANEL_TOOLTIP,
  ADD_PANEL_INITIAL_TOOLTIP,
  dismissV3ToolGuidance,
  dismissMoveArrayGuidance,
  MARK_ROOF_TOOLTIP,
  MARK_ROOF_INITIAL_TOOLTIP,
  showMoveArrayGuidance,
  showV3ToolGuidance,
  V3ToolHoverTooltip,
} from './tooltips/V3ToolGuidance';

const MIN_ZOOM = 1;
const MAX_ZOOM = 22;

function hasFiniteLatLng(lat: number, lng: number): boolean {
  return Number.isFinite(lat) && Number.isFinite(lng);
}

type OwnProps = {
  productId: string;
  projectId?: string;
  projectName?: string;
  user?: { email?: string; username?: string };
  dispatch?: Function;
  editorReady?: boolean;
  numericProductId?: number;
  selectedMfgId?: number | null;
  selectedModelId?: number | null;
  mfgs?: { id: number; name: string }[];
  models?: { id: number; name: string }[];
  modelData?: any;
};

type ReduxProps = {
  lat?: number;
  lng?: number;
  zipcode?: string;
  address?: string;
  advanceRoofSelecting?: {
    enabled: boolean;
    roofPoints: any[];
    lastPoint: any;
  };
  selectedRoofId?: number | null;
  backgroundCords?: cordPoint | null;
  showArrayNumber?: boolean;
  moveArrayMode?: boolean;
  panels?: any[];
  userProfiles?: UserProfile[];
  userProfilesLoading?: boolean;
  lastCreatedProfile?: { id: number | null; title: string | null; projectId: string | null } | null;
  profileSaving?: boolean;
  projectVariables?: { [name: string]: string };
  // Sourced from projectEnvConfig.domestic_content. Coerced to boolean here;
  // persisted/written as 1/0 because the backend column is a
  // PositiveSmallIntegerField with YES_OR_NO choices.
  domesticContent?: boolean;
  liteUpdating?: boolean;
  liteDirty?: boolean;
  stageScale?: { x: number; y: number };
};

type Props = OwnProps & ReduxProps;

type SelectableItem = {
  id: number;
  kind: 'panel' | 'obstruction';
  x: number;
  y: number;
  width: number;
  height: number;
  landscape?: boolean;
};

type SelectionRect = {
  x: number;
  y: number;
  w: number;
  h: number;
};

type State = {
  activeTool: string | null;
  orientation: 'portrait' | 'landscape';
  viewMode: 'canvas' | 'satellite';
  navigateMode: boolean;
  zoom: number;
  unitMode: 'Imperial' | 'Metric';
  selectedPanelIds: number[];
  selectedObstructionIds: number[];
  marqueeRect: SelectionRect | null;
  selectionDimsLabel: string | null;
  selectionError: string | null;
  pendingViewSwitch: boolean;
  switchingView: boolean;
  editorKey: number;
  moveMode: boolean;
  saveProfileOpen: boolean;
  saveProfileName: string;
  // Identifier and name of the user profile currently associated with the
  // open project. Both are either null/undefined together or both populated
  // together — the save-profile modal logic relies on this paired invariant
  // to decide between PUT (update) and POST (create + persist new id as a
  // ProjectVariable). Sourced from projectEnvConfig.profile_id (round-tripped
  // through the FETCH_PROJECT serializer) cross-referenced against the
  // userProfiles list to resolve the title.
  currentProfileId: number | null;
  currentProfileName: string | null;
  // Tracks the title used to dispatch the most recent SAVE_USER_PROFILE_REQUEST
  // so that when the matching SUCCESS arrives (lastCreatedProfile prop updates),
  // we can adopt the new id/title and chain the profile_id ProjectVariable
  // write via UPDATE_LITE_PROJECT_REQUEST. Cleared after adoption.
  pendingCreateProfileTitle: string | null;
  clearAllConfirmOpen: boolean;
  leftPanelCollapsed: boolean;
  rightPanelCollapsed: boolean;
  labelsHidden: boolean;
  addPanelInitialTooltipDismissed: boolean;
  markRoofInitialTooltipDismissed: boolean;
  advancedForceOpenSignal: number;
  domesticClampTarget: number | null;
  pendingDomesticTurningOn: boolean | null;
};

const FLIP_OVERLAP_ERROR = 'Cannot flip selected objects as they would overlap with other objects.';
const MOVE_OVERLAP_ERROR = 'Cannot move selected objects as they overlap with other objects.';

function readReduxOrientation(): 'portrait' | 'landscape' {
  const s = state() as any;
  return s && s.editorCursor && s.editorCursor.landscape ? 'landscape' : 'portrait';
}

// Read the persisted view mode at construction time. PanelsEditor's
// componentDidMount runs synchronously off the first paint and reads
// background.cords; for a satellite-saved project, cords is null until the
// user enters the per-roof editor. If we default to 'canvas' and flip in
// componentDidMount, PanelsEditor still mounts once with cords=null and
// crashes in getGoogleMapImageLink. Initial state must already be correct.
function readReduxViewMode(): 'canvas' | 'satellite' {
  const s = state() as any;
  const mapType = s && s.roofsSelector && s.roofsSelector.mapType;
  return (mapType && mapType !== MAP_TYPE.BLANK) ? 'satellite' : 'canvas';
}

function getSettings(): { canvasCenter: { x: number; y: number }; metersPerPixel: number } {
  const s = state() as any;
  const canvasCenter = (s && s.settings && s.settings.canvasCenter) || { x: 0, y: 0 };
  const metersPerPixel = (s && s.background && s.background.metersPerPixel) || 0;
  return { canvasCenter, metersPerPixel };
}

function getPanels(): any[] {
  const s = state() as any;
  if (s && s.panels && Array.isArray(s.panels.panels)) {
    return s.panels.panels;
  }
  return [];
}

function hasUserMarkedRoof(): boolean {
  const s = state() as any;
  const roofs = s && s.drawingManager && s.drawingManager.roofs;
  if (!roofs) return false;

  return Object.keys(roofs).some((roofId) => {
    const id = parseInt(roofId, 10);
    const roof = roofs[roofId];
    if (id === 0) return false;
    if (id === 1 && roof && roof.marker && roof.marker.lat === 35.0844 && roof.marker.lng === -106.6504) {
      return false;
    }
    return true;
  });
}

function getObstructions(): any[] {
  const s = state() as any;
  const obs = s && s.obstructions;
  if (!obs) return [];
  if (Array.isArray(obs)) return obs;
  if (Array.isArray(obs.obstructions)) return obs.obstructions;
  return [];
}

function toAABB(item: any, kind: 'panel' | 'obstruction'): SelectableItem | null {
  if (!item || typeof item.x !== 'number' || typeof item.y !== 'number') return null;
  const width = typeof item.width === 'number' ? item.width : item.w;
  const height = typeof item.height === 'number' ? item.height : item.h;
  if (typeof width !== 'number' || typeof height !== 'number') return null;
  return {
    id: item.id,
    kind,
    x: item.x,
    y: item.y,
    width,
    height,
    landscape: !!item.landscape,
  };
}

function getItemBounds(item: SelectableItem): { left: number; top: number; right: number; bottom: number; cx: number; cy: number } {
  const halfW = item.width / 2;
  const halfH = item.height / 2;
  return {
    left: item.x - halfW,
    top: item.y - halfH,
    right: item.x + halfW,
    bottom: item.y + halfH,
    cx: item.x,
    cy: item.y,
  };
}

function aabbIntersect(a: SelectableItem, b: SelectableItem): boolean {
  const ba = getItemBounds(a);
  const bb = getItemBounds(b);
  return !(ba.right <= bb.left || ba.left >= bb.right || ba.bottom <= bb.top || ba.top >= bb.bottom);
}

function getPanelSpriteScreenPositions(ids?: number[]): Map<number, { x: number; y: number; w?: number; h?: number }> | null {
  try {
    const container: any = getPanelsContainer ? getPanelsContainer() : null;
    if (!container || !Array.isArray(container.children)) return null;
    if (typeof container.updateTransform === 'function') {
      container.updateTransform();
    }
    const idSet = ids ? new Set(ids) : null;
    const out = new Map<number, { x: number; y: number; w?: number; h?: number }>();
    for (const sprite of container.children) {
      if (!sprite || typeof sprite.id !== 'number') continue;
      if (idSet && !idSet.has(sprite.id)) continue;
      let cx: number | null = null;
      let cy: number | null = null;
      let bw = 0;
      let bh = 0;
      if (typeof sprite.getBounds === 'function') {
        try {
          const b = sprite.getBounds();
          if (b && typeof b.x === 'number' && typeof b.y === 'number'
            && typeof b.width === 'number' && typeof b.height === 'number') {
            cx = b.x + b.width / 2;
            cy = b.y + b.height / 2;
            bw = b.width;
            bh = b.height;
          }
        } catch (_) { /* ignore */ }
      }
      if (cx === null || cy === null) {
        const wt = sprite.worldTransform;
        if (wt && typeof wt.tx === 'number' && typeof wt.ty === 'number') {
          cx = wt.tx;
          cy = wt.ty;
        }
      }
      if (cx === null || cy === null) continue;
      out.set(sprite.id, { x: cx, y: cy, w: bw, h: bh });
    }
    return out.size > 0 ? out : null;
  } catch (_) {
    return null;
  }
}

function getPanelsContainerScale(): { x: number; y: number } {
  try {
    const container: any = getPanelsContainer ? getPanelsContainer() : null;
    if (!container) return { x: 1, y: 1 };
    const wt = container.worldTransform;
    if (wt && typeof wt.a === 'number' && typeof wt.d === 'number') {
      const sx = Math.sqrt(wt.a * wt.a + (wt.b || 0) * (wt.b || 0)) || 1;
      const sy = Math.sqrt((wt.c || 0) * (wt.c || 0) + wt.d * wt.d) || 1;
      return { x: sx, y: sy };
    }
    if (container.scale && typeof container.scale.x === 'number' && typeof container.scale.y === 'number') {
      return { x: container.scale.x || 1, y: container.scale.y || 1 };
    }
  } catch (_) { /* ignore */ }
  return { x: 1, y: 1 };
}

function rectContainsPoint(r: SelectionRect, px: number, py: number): boolean {
  return px >= r.x && px <= r.x + r.w && py >= r.y && py <= r.y + r.h;
}

function formatInches(px: number, metersPerPixel: number): string {
  if (!metersPerPixel) return `${Math.round(px)}px`;
  const meters = px * metersPerPixel;
  const inches = meters * 39.3701;
  const ft = Math.floor(inches / 12);
  const rem = Math.round(inches - ft * 12);
  if (ft <= 0) return `${rem}"`;
  return `${ft}'-${rem}"`;
}

class DesignWorkspace extends React.Component<Props, State> {
  private storeUnsubscribe: (() => void) | null = null;
  private pendingProfileAdvanced: { [key: string]: any } | null = null;
  private mapContainerRef: React.RefObject<HTMLDivElement> = React.createRef();
  private map: google.maps.Map | null = null;
  private overlayRef: HTMLDivElement | null = null;
  private marqueeStart: { x: number; y: number } | null = null;
  private isDragging: boolean = false;
  private errorTimer: number | null = null;
  // Per-roof undo history. Saved on roof exit, restored on roof re-entry,
  // so each roof keeps its own undo stack across visits.
  private _perRoofHistory: { [roofId: number]: any } = {};
  // Satellite-mode location search (Google Places Autocomplete on the toolbar
  // input). Attached after the map initializes; cleaned up in destroyMap.
  private searchInputRef: React.RefObject<HTMLInputElement> = React.createRef();
  private searchAutocomplete: any = null;
  private searchListener: any = null;
  // Last satellite camera (center + zoom). Search uses fitBounds, which is
  // not zoom 20; restoring lat/lng at a hardcoded zoom made the pin look
  // like it moved. Captured on search-idle and again on map teardown so a
  // blank-map round-trip returns to the same view.
  private lastSatelliteCamera: { lat: number; lng: number; zoom: number } | null = null;
  private searchMarker: google.maps.Marker | null = null;
  private moveOriginalPanels: any[] = [];
  private moveResumeBase: any[] = [];
  private moveAnchor: { x: number; y: number } | null = null;
  private isMiddleSuspended: boolean = false;
  private selectToolStoreUnsubscribe: (() => void) | null = null;
  private suppressedSprites: { sprite: any; originalEmit: Function }[] = [];
  private selectToolSuppressionActive: boolean = false;
  private canvasToOverlayCache: { scaleX: number; scaleY: number; offsetX: number; offsetY: number } | null = null;
  private tickerId: number | null = null;
  private isUnmounted: boolean = false;

  state: State = {
    activeTool: 'addpanel',
    orientation: readReduxOrientation(),
    viewMode: readReduxViewMode(),
    navigateMode: false,
    zoom: 19,
    unitMode: 'Imperial',
    selectedPanelIds: [],
    selectedObstructionIds: [],
    marqueeRect: null,
    selectionDimsLabel: null,
    selectionError: null,
    pendingViewSwitch: false,
    switchingView: false,
    editorKey: 0,
    moveMode: false,
    saveProfileOpen: false,
    saveProfileName: '',
    currentProfileId: null,
    currentProfileName: null,
    pendingCreateProfileTitle: null,
    clearAllConfirmOpen: false,
    leftPanelCollapsed: false,
    rightPanelCollapsed: false,
    labelsHidden: false,
    addPanelInitialTooltipDismissed: false,
    markRoofInitialTooltipDismissed: false,
    advancedForceOpenSignal: 0,
    domesticClampTarget: null,
    pendingDomesticTurningOn: null,
  };

  componentDidMount() {
    // Initial state already reflects roofsSelector.mapType (see readReduxViewMode),
    // so PanelsEditor doesn't mount with cords=null on satellite reopens. We
    // still need to bring up the live map here because componentDidUpdate's
    // becameSatellite check won't fire (prev and current both 'satellite').
    if (this.state.viewMode === 'satellite') {
      this.pendingRehydrate = true;
      setTimeout(() => this.initMap(), 0);
    } else {
      // Blank/canvas design opens straight into the panels editor — make
      // Add Panel the default selected tool on arrival.
      this.selectTool('addpanel');
    }

    this.storeUnsubscribe = reduxStore.subscribe(() => {
      this.drainPendingProfileAdvanced();
      const next = readReduxOrientation();
      if (next !== this.state.orientation) {
        this.setState({ orientation: next });
      }
    });
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('resize', this.handleWindowResize);
    document.addEventListener('click', this.handleRemoveObsClick);
    if (this.state.activeTool === 'select') {
      this.attachSelectListeners();
    }

    this.ensureModuleSelectorHydrated();
    this.loadPendingProfileAdvanced();
    this.drainPendingProfileAdvanced();

    reduxDispatch(ENABLE_ARRAY_NUMBER_FEATURE());

    // Fetch the user's profile list so the save-profile modal can resolve the
    // current project's profile_id (a ProjectVariable round-tripped through
    // projectVariables) to a display title. Cheap GET — backend already
    // scopes by request.user + is_active=True.
    if (this.props.dispatch) {
      if (!(this.props.userProfiles && this.props.userProfiles.length > 0)) {
        this.props.dispatch(FETCH_USER_PROFILES_REQUEST());
      }
      // Also fetch the project's ProjectVariable values (profile_id is the
      // one we consume; the FETCH_PROJECT response doesn't expose them).
      // Hydration runs in componentDidUpdate once the response arrives —
      // not here, because this.props.projectVariables at mount time is the
      // stale slice from a prior workspace session in the same Redux store.
      if (this.props.projectId) {
        const vars = this.props.projectVariables || {};
        const isCurrentProject = vars.projectId === this.props.projectId;
        if (!isCurrentProject) {
          this.props.dispatch(FETCH_PROJECT_VARIABLES_REQUEST({ projectId: this.props.projectId }));
        }
      }
    }
  }

  loadPendingProfileAdvanced = () => {
    let raw: string | null = null;
    try { raw = window.localStorage.getItem('lite_pending_profile_advanced'); } catch (_) { return; }
    if (!raw) return;
    try { window.localStorage.removeItem('lite_pending_profile_advanced'); } catch (_) { /* ignore */ }
    let parsed: any = null;
    try { parsed = JSON.parse(raw); } catch (_) { return; }
    if (!parsed || !parsed.fields || typeof parsed.fields !== 'object') return;
    if (typeof parsed.ts === 'number' && Date.now() - parsed.ts > 5 * 60 * 1000) return;
    const fields: { [key: string]: any } = {};
    Object.keys(parsed.fields).forEach((key) => {
      if (key === 'roof_pitch') return;
      const value = parsed.fields[key];
      if (value === null || value === undefined) return;
      fields[key] = value;
    });
    if (Object.keys(fields).length === 0) return;
    this.pendingProfileAdvanced = fields;
  }

  drainPendingProfileAdvanced = () => {
    if (!this.pendingProfileAdvanced) return;
    const s = state() as any;
    const pc = (s && s.projectConfiguration) || {};
    const env = pc.projectEnvConfig || {};
    const envHydrated = !!pc.productId && Object.keys(env).length > 0;
    if (!envHydrated) return;
    const fields = this.pendingProfileAdvanced;
    this.pendingProfileAdvanced = null;
    Object.keys(fields).forEach((key) => {
      reduxDispatch(SET_PROJECT_OPTION(key, fields[key]));
    });
  }

  ensureModuleSelectorHydrated = () => {
    const { productId } = this.props;
    const s = state() as any;
    const env = (s && s.projectConfiguration && s.projectConfiguration.projectEnvConfig) || {};
    const ms = (s && s.moduleSelector) || {};
    const hasModelData = ms.modelData && Object.keys(ms.modelData).length > 0;
    const mfgIdRaw = env.module_id ?? env.module;
    const modelIdRaw = env.model_id ?? env.model;
    const mfgId = typeof mfgIdRaw === 'number' ? mfgIdRaw : (mfgIdRaw !== undefined && mfgIdRaw !== null && !isNaN(Number(mfgIdRaw)) ? Number(mfgIdRaw) : null);
    const modelId = typeof modelIdRaw === 'number' ? modelIdRaw : (modelIdRaw !== undefined && modelIdRaw !== null && !isNaN(Number(modelIdRaw)) ? Number(modelIdRaw) : null);
    const productSlug = productId || (s && s.projectConfiguration && s.projectConfiguration.productId
      ? Object.keys(products).find((k) => (products as any)[k] === s.projectConfiguration.productId)
      : null);
    if (!productSlug || !mfgId || !modelId) return;
    if (hasModelData && ms.selectedMfgId === mfgId && ms.selectedModelId === modelId) return;
    // loadProject's setPanelsModel already fires FETCH_MFGS_AND_MODELS_REQUEST
    // during container hydration — that fetches the mfg list AND chains an
    // identical tool/models GET for this manufacturer, flipping allInLoading /
    // modelsLoading and setting selectedMfgId synchronously (SET_MFG). When that
    // load-path fetch is still in flight for the same mfg, re-dispatching here
    // just duplicates the same request, so skip and let it populate modelData.
    if ((ms.allInLoading || ms.modelsLoading) && ms.selectedMfgId === mfgId) return;
    reduxDispatch(FETCH_MFG_MODELS_REQUEST(productSlug, mfgId, modelId, undefined, config.currentProjectVersion));
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const { viewMode } = this.state;
    const becameSatellite = viewMode === 'satellite' && prevState.viewMode !== 'satellite';
    const leftSatellite = viewMode !== 'satellite' && prevState.viewMode === 'satellite';

    // Track entering/exiting per-roof panels-editor sub-mode while in satellite.
    // Legacy hides the map and shows PanelsEditor on the active roof; when the
    // user clicks Back (DEACTIVE_PANELS_EDITOR), we restore the map.
    const inSat = viewMode === 'satellite';
    const wasInSat = prevState.viewMode === 'satellite';
    const enteredEditor = inSat && wasInSat && !prevProps.selectedRoofId && this.props.selectedRoofId;
    const leftEditor = inSat && wasInSat && prevProps.selectedRoofId && !this.props.selectedRoofId;

    // Force landscape orientation in satellite view for commercial products only.
    const satPid = this.getNumericProductId();
    if (satPid && isCommercialProduct(satPid) && this.state.orientation !== 'landscape') {
      this.handleOrientationChange('landscape');
    }
    if (becameSatellite) {
      // Navigate Map is the default mode in satellite roof-marking view.
      this.setState({ navigateMode: true });

      // Also rehydrate any saved/redux roofs once the map is ready, so a
      // satellite-saved project shows its marked roofs on first paint.
      this.pendingRehydrate = true;
      setTimeout(() => this.initMap(), 0);
    }

    if (leftSatellite) {
      this.destroyMap();
      // Switched to blank/canvas design → Add Panel is the default tool.
      this.selectTool('addpanel');
    }

    if (enteredEditor) {
      // Entering spotlight — Navigate Map off, Add Panel is default.
      this.selectTool('addpanel');
      // Roof was selected → tear down the live map so PanelsEditor renders
      // the satellite-image background. Keep mapType as 'google' so the
      // editor's static-map background loads correctly.
      this.tearDownMap(false);
    }

    if (leftEditor) {
      // Back to roof-marking — Navigate Map is default again.
      this.setState({ navigateMode: true });
      // Returned to roof-selection view → bring the map back AND recreate
      // the previously marked roofs (they live in drawingManager.roofs but
      // their google.maps.Polygon instances were attached to the old map).
      this.pendingRehydrate = true;
      setTimeout(() => this.initMap(), 0);
    }

    // Per-roof undo history: save the outgoing roof's history, then
    // restore the incoming roof's saved history (or seed a fresh one).
    if (this.props.selectedRoofId !== prevProps.selectedRoofId) {
      // Save outgoing roof's history
      if (prevProps.selectedRoofId) {
        const s = state() as any;
        if (s.liteHistory) {
          this._perRoofHistory[prevProps.selectedRoofId] = {
            panelsSnapshot: s.liteHistory.panelsSnapshot,
            index: s.liteHistory.index,
            canUndo: s.liteHistory.canUndo,
            canRedo: s.liteHistory.canRedo,
          };
        }
      }
      // Restore incoming roof's history (or seed fresh)
      if (this.props.selectedRoofId) {
        const saved = this._perRoofHistory[this.props.selectedRoofId];
        if (saved) {
          reduxDispatch(LITE_RESTORE_HISTORY(saved));
        } else {
          const s = state() as any;
          const panels = (s.panels && s.panels.panels) || [];
          reduxDispatch(LITE_SEED_HISTORY(panels));
        }
      }
    }

    // Re-render the Pixi drawing layer when advanceRoofSelecting state changes
    // (vertex added, cursor moved, etc.) — mirrors original googleMapsRoofsSelector.tsx.
    const { advanceRoofSelecting: ars } = this.props;
    const prevArs = prevProps.advanceRoofSelecting;
    const arsDrawingChanged = !prevArs
      || prevArs.enabled !== (ars && ars.enabled)
      || prevArs.roofPoints !== (ars && ars.roofPoints)
      || prevArs.lastPoint !== (ars && ars.lastPoint);
    // Satellite map roof marking only — per-roof editor (obstructions, etc.)
    // renders via panelsEditor → renderAdvanceSelectingOnStage().
    const inSatelliteMapView = this.state.viewMode === 'satellite' && !this.props.selectedRoofId;
    if (inSatelliteMapView && arsDrawingChanged && ars && ars.enabled && ars.roofPoints && ars.roofPoints.length && ars.lastPoint) {
      renderAdanvaceRoofSelecting();
    }

    const wasSelect = prevState.activeTool === 'select';
    const isSelect = this.state.activeTool === 'select';
    if (isSelect && !wasSelect) {
      this.attachSelectListeners();
    } else if (!isSelect && wasSelect) {
      this.detachSelectListeners();
    }

    this.applyBodyCursorClass();

    // Re-attempt hydration once the userProfiles list arrives or the
    // ProjectVariables fetch resolves. Both are post-mount asynchronous, so
    // on first paint at least one lookup typically fails; this catches the
    // prop transition without polling Redux.
    const prevProfiles = prevProps.userProfiles || [];
    const nextProfiles = this.props.userProfiles || [];
    const profilesArrived = prevProfiles.length === 0 && nextProfiles.length > 0;
    const prevVars = prevProps.projectVariables || {};
    const nextVars = this.props.projectVariables || {};
    const varsArrived = prevVars !== nextVars
      && (prevVars.profile_id === undefined || prevVars.profile_id === '')
      && !!nextVars.profile_id;
    if (profilesArrived || varsArrived) {
      this.hydrateCurrentProfile();
    }
    if (prevProfiles !== nextProfiles && this.state.currentProfileId !== null) {
      const current = nextProfiles.find((p) => p && p.id === this.state.currentProfileId);
      if (current && current.title !== this.state.currentProfileName) {
        this.setState({ currentProfileName: current.title || null });
      } else if (!current) {
        this.setState({ currentProfileId: null, currentProfileName: null });
      }
    }

    // React Router reuses UBuilderLiteContainer (and therefore this
    // workspace) across navigations that only swap projectId in the URL —
    // componentDidMount does NOT run again on those transitions. Without
    // this branch, currentProfileId/currentProfileName from the previous
    // project would persist into the new one, defaulting the Save Profile
    // input to a stale name. Clear local state and re-fetch the new
    // project's variable dict so hydration runs against the right data.
    if (prevProps.projectId !== this.props.projectId) {
      this.setState({
        currentProfileId: null,
        currentProfileName: null,
        pendingCreateProfileTitle: null,
      });
      if (this.props.dispatch && this.props.projectId) {
        const vars = this.props.projectVariables || {};
        const isCurrentProject = vars.projectId === this.props.projectId;
        if (!isCurrentProject) {
          this.props.dispatch(FETCH_PROJECT_VARIABLES_REQUEST({ projectId: this.props.projectId }));
        }
      }
    }

    // Adopt a newly created profile. When SAVE_USER_PROFILE_SUCCESS lands,
    // the reducer populates lastCreatedProfile with the server-assigned id
    // and the projectId the save was initiated for. We:
    //   1. Adopt id+title locally so subsequent opens of the modal default
    //      to the new name and the update path becomes available.
    //   2. Chain UPDATE_LITE_PROJECT_REQUEST so the profile_id is persisted
    //      as a ProjectVariable on the project (round-tripped on reload via
    //      projectEnvConfig.profile_id).
    // We compare against pendingCreateProfileTitle to ignore profile saves
    // initiated outside this workspace instance.
    const prevLc = prevProps.lastCreatedProfile;
    const nextLc = this.props.lastCreatedProfile;
    if (
      nextLc
      && nextLc !== prevLc
      && nextLc.id !== null
      && nextLc.projectId
      && this.state.pendingCreateProfileTitle
      && nextLc.title === this.state.pendingCreateProfileTitle
      && nextLc.projectId === this.props.projectId
    ) {
      const adoptedId = nextLc.id;
      const adoptedTitle = nextLc.title;
      this.setState({
        currentProfileId: adoptedId,
        currentProfileName: adoptedTitle,
        pendingCreateProfileTitle: null,
      });
      // Stash the new id in projectEnvConfig so the autosave PUT body
      // (built by buildLiteUpdatePayload from the current store snapshot)
      // includes it; backend will pop the key and write the ProjectVariable.
      reduxDispatch(SET_PROJECT_OPTION('profile_id', String(adoptedId)));
      if (this.props.dispatch && this.props.projectId && !this.props.liteUpdating) {
        this.props.dispatch(UPDATE_LITE_PROJECT_REQUEST({ projectId: this.props.projectId }));
      }
    }
    const prevPanels = prevProps.panels || [];
    const nextPanels = this.props.panels || [];
    if (this.state.activeTool === 'addpanel' && nextPanels.length > prevPanels.length) {
      this.selectTool('addpanel');
    }
    if (this.state.activeTool === 'removepanel' && nextPanels.length < prevPanels.length) {
      this.selectTool('removepanel');
    }
    if (prevPanels.length !== nextPanels.length && this.props.showArrayNumber) {
      this.refreshArrayNumbers();
    }
  }

  applyBodyCursorClass = () => {
    const { activeTool, moveMode } = this.state;
    document.body.classList.remove('v3-select-cursor-crosshair', 'v3-select-cursor-move');
    if (activeTool !== 'select') return;
    if (moveMode) {
      document.body.classList.add('v3-select-cursor-move');
    } else {
      document.body.classList.add('v3-select-cursor-crosshair');
    }
  }

  componentWillUnmount() {
    this.isUnmounted = true;
    // Defensive: clear any in-flight per-roof editor selection before the
    // parent UBuilderLiteContainer's unmount fires its savePanelsEditor chain.
    // If selectedRoofId points at a roof that no longer exists in
    // drawingManager.roofs (e.g., satellite roofs we wiped earlier in the
    // session), savePanelsEditor crashes reading roofs[selectedRoofId].xxx.
    reduxDispatch(DEACTIVE_PANELS_EDITOR());

    // Tear down the live map but DO NOT reset mapType — the parent's autosave
    // (UBuilderLiteContainer.maybeAutoSave) runs after this and reads
    // roofsSelector.mapType to set the persisted map_type. Resetting here
    // would clobber 'google' → 'blank', and the project would always reopen
    // in design view regardless of where the user closed it.
    this.tearDownMap(false);
    if (this.storeUnsubscribe) {
      this.storeUnsubscribe();
      this.storeUnsubscribe = null;
    }
    this.endPanelSpriteRemovalSuppression();
    if (this.errorTimer !== null) {
      window.clearTimeout(this.errorTimer);
      this.errorTimer = null;
    }
    this.detachSelectListeners();
    this.stopHighlightTicker();
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('resize', this.handleWindowResize);
    document.removeEventListener('click', this.handleRemoveObsClick);
    document.body.classList.remove('v3-select-cursor-crosshair', 'v3-select-cursor-move');
    dismissV3ToolGuidance();
    dismissMoveArrayGuidance();
  }

  // ── Satellite map lifecycle ──────────────────────────────────────────

  // Tracks whether the next initMap() should also rehydrate marked roofs
  // (used when returning from the per-roof editor — the polygons live in
  // redux but their Google Maps overlays were tied to the torn-down map).
  private pendingRehydrate: boolean = false;

  initMap = () => {
    const container = this.mapContainerRef.current;
    if (!container) return;

    const g = (window as any).google;
    if (!g || !g.maps) return;

    // Disable PanelsEditor's keyboard handler (Escape → ADD_OBSTRUCTION conflict).
    terminateKeyboard();
    // Clear legacy stage events (dblclick.roofsSelectorStage) which conflict
    // with Lite's own satellite dblclick handler for completing roof polygons.
    clearLegacyStageEvents();

    // Tell the original system this is a Google Maps satellite view.
    reduxDispatch(SET_DEFAULT_MAP_ROOFS_SELECTOR());

    // Prevent the original's center_changed handler from re-geocoding on every pan.
    setShouldSkipFetZipCode(true);

    // Use the ORIGINAL UBuilder's initializeMap — this sets the module-level
    // singleton so every original helper (getMap(), initPixi(), createRoofArea(),
    // edge labels, center markers, etc.) works without modification.
    this.map = initializeMap(container, false, {
      scrollwheel: true,
      gestureHandling: 'greedy',
      disableDoubleClickZoom: true,
    });

    this.map.addListener('click', () => {
      removePlaceMarker();
    });

    // Whether this is a reopened project that already has marked roofs (their
    // coords live in redux even before the Google Maps overlays are recreated
    // by rehydrateRoofs). The lite seed roof (id=0) is bookkeeping-only — its
    // coords are the Albuquerque defaults — so it doesn't count as a real roof.
    const initState = state() as any;
    const savedRoofs = initState && initState.drawingManager && initState.drawingManager.roofs;
    const hasMarkedRoofs = !!savedRoofs
      && Object.keys(savedRoofs).some(roofId => {
        const id = parseInt(roofId, 10);
        if (id === 0) return false;
        // If it's the seeded canvas roof (id=1) at the Albuquerque default,
        // it doesn't count as a "marked" roof in satellite mode.
        const r = savedRoofs[roofId];
        if (id === 1 && r && r.marker && r.marker.lat === 35.0844 && r.marker.lng === -106.6504) {
          return false;
        }
        return true;
      });

    // Once the map tiles are loaded, initialize the Pixi drawing layer.
    // We wire our OWN keyboard handlers (not initStageEvents()) so we can
    // wrap deployAdvanceRoofSelecting in a try-catch — the original's
    // overlap-check throws when the PixiLayer projection hasn't stabilized,
    // and the uncaught exception aborts finalization.
    g.maps.event.addListenerOnce(this.map, 'idle', () => {
      clearPixiLayer();
      initPixi();
      this.bindSatelliteEvents();

      if (this.pendingRehydrate) {
        this.pendingRehydrate = false;
        this.rehydrateRoofs();
        // Fit every restored roof in the viewport. Centering on only the first
        // roof at a fixed zoom made a newly-added second roof appear to vanish
        // after returning from its panel editor.
        if (hasMarkedRoofs && this.map) {
          const restoredRoofs = getAllGoogleRoofObject();
          if (restoredRoofs && Object.keys(restoredRoofs).length) {
            centerMapOnRoofs(restoredRoofs);
          }
        }
      }

      if (this.state.activeTool === 'markroof') {
        reduxDispatch(TURN_ON_ROOF_SELECTING());
        turnGoogleMapsOffMapMoveControls();
      }
    });

    // Keep zoom state in sync.
    this.map.addListener('zoom_changed', () => {
      if (this.map) {
        this.setState({ zoom: this.map.getZoom() });
      }
    });

    // Center on the project's exact lat/lng when available (create-modal
    // geocode or a later address search). Fall back to the project's full
    // address or the ZIP centroid for legacy projects that never stored
    // coords. Address/ZIP must not win over lat/lng: searching updates
    // zipcode immediately but used to leave client_address stale, so
    // geocoding address after a blank-map round-trip jumped back to the
    // original site. Skipped when marked roofs exist — the idle handler
    // above centers on those, and an async geocode would race and override.
    const { lat, lng, zipcode, address } = this.props;
    const latNum = typeof lat === 'number' ? lat : Number(lat);
    const lngNum = typeof lng === 'number' ? lng : Number(lng);
    const pinPos = hasFiniteLatLng(latNum, lngNum)
      ? new g.maps.LatLng(latNum, lngNum)
      : null;
    if (hasMarkedRoofs) {
      // no-op: roof centering handled in the idle listener above
      removePlaceMarker();
    } else if (this.lastSatelliteCamera) {
      const cam = this.lastSatelliteCamera;
      this.map.setCenter({ lat: cam.lat, lng: cam.lng });
      this.map.setZoom(cam.zoom);
      this.setState({ zoom: cam.zoom });
      setPlaceMarker(pinPos || new g.maps.LatLng(cam.lat, cam.lng));
    } else if (pinPos) {
      this.map.setCenter(pinPos);
      this.map.setZoom(20);
      setPlaceMarker(pinPos);
    } else if (address || zipcode) {
      const geocoder = new g.maps.Geocoder();
      geocoder.geocode({ address: address || zipcode }, (results: any[], status: string) => {
        if (status === 'OK' && results && results[0] && this.map) {
          const loc = results[0].geometry.location;
          this.map.setCenter(loc);
          this.map.setZoom(20);
          setPlaceMarker(loc);
        }
      });
    }
    

    this.attachLocationSearch();
    if (this.searchInputRef.current && address) {
      this.searchInputRef.current.value = address;
    }
  }

  // Wires Google Places Autocomplete to the satellite toolbar's search input.
  // On place pick: if roofs exist, show a warning dialog and delete all roofs
  // on confirmation (matching original UBuilder behavior). Otherwise pan the map.
  attachLocationSearch = () => {
    const input = this.searchInputRef.current;
    const g = (window as any).google;
    if (!input || !g || !g.maps || !g.maps.places || this.searchAutocomplete) return;
    this.searchAutocomplete = new g.maps.places.Autocomplete(input, { types: ['geocode'] });
    this.searchListener = this.searchAutocomplete.addListener('place_changed', () => {
      const place = this.searchAutocomplete.getPlace();
      if (!place || !place.geometry || !place.geometry.location || !this.map) return;

      const appState = state() as any;
      const roofs = appState.drawingManager && appState.drawingManager.roofs;
      const hasRoofs = roofs && Object.keys(roofs).length > 0;

      const loc = place.geometry.location;
      const applyNewLocation = () => {
        if (place.geometry.viewport) {
          this.map.fitBounds(place.geometry.viewport);
        } else {
          this.map.setCenter(loc);
          this.map.setZoom(20);
        }
        setPlaceMarker(loc);
        const nextLat = loc.lat();
        const nextLng = loc.lng();
        reduxDispatch(SET_PROJECT_OPTION('lat', nextLat));
        reduxDispatch(SET_PROJECT_OPTION('lng', nextLng));
        reduxDispatch(SET_MAP_CENTER({ lat: nextLat, lng: nextLng }));
        // Persist the searched street address (not just zipcode) so a
        // blank-map round-trip / reload still geocodes the same place.
        const nextAddress = (place.formatted_address || input.value || '').slice(0, 155);
        if (nextAddress) {
          reduxDispatch(SET_PROJECT_OPTION('client_address', nextAddress));
          reduxDispatch(SET_PROJECT_OPTION('location', nextAddress));
          reduxDispatch(SET_LOCATION(nextAddress));
          input.value = nextAddress;
        }
        changeCityAndZipCode(loc);
        // fitBounds finishes asynchronously; capture the settled camera so
        // returning from blank map uses the same center and zoom, not zoom 20.
        g.maps.event.addListenerOnce(this.map, 'idle', () => {
          this.persistSatelliteCamera();
        });
      };

      if (hasRoofs) {
        // Show warning — on confirm, delete all roofs and pan to new location.
        reduxDispatch(OPEN_CONFIRM_CLEAR_ARRAYS_MODAL(
          'Change map location',
          'Changing map location will remove all installations. Are you sure?',
          () => {
            clearLastZipCode();
            deleteAllGoogleRoofs();
            applyNewLocation();
          },
        ));
      } else {
        // No roofs drawn — pan to the new location freely.
        clearLastZipCode();
        applyNewLocation();
      }
    });
  }

  detachLocationSearch = () => {
    const g = (window as any).google;
    if (this.searchListener && g && g.maps && g.maps.event) {
      g.maps.event.removeListener(this.searchListener);
    }
    this.searchListener = null;
    this.searchAutocomplete = null;
    // Google appends `.pac-container` dropdowns to <body>; clear leftovers.
    document.querySelectorAll('.pac-container').forEach((el) => el.remove());
  }

  // Tears down the live Google Maps + Pixi instances and our event handlers.
  // Does NOT reset mapType — that's only correct when we're leaving satellite
  // mode entirely (back to canvas). When entering the per-roof editor, we
  // need mapType to stay 'google' so PanelsEditor renders the satellite
  // static-image background instead of the lite blank canvas.
  persistSatelliteCamera = () => {
    if (!this.map || typeof this.map.getCenter !== 'function') return;
    const center = this.map.getCenter();
    const zoom = this.map.getZoom();
    if (!center || !Number.isFinite(zoom)) return;
    const lat = typeof center.lat === 'function' ? center.lat() : (center as any).lat;
    const lng = typeof center.lng === 'function' ? center.lng() : (center as any).lng;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
    this.lastSatelliteCamera = { lat, lng, zoom };
    reduxDispatch(SET_MAP_CENTER({ lat, lng }));
    reduxDispatch(SET_MAP_ZOOM(zoom));
  }

  tearDownMap = (resetMapType: boolean) => {
    this.persistSatelliteCamera();
    this.unbindSatelliteEvents();
    this.detachLocationSearch();
    reduxDispatch(TURN_OFF_ROOF_SELECTING());
    clearPixiLayer();
    removeMap();
    if (resetMapType) {
      reduxDispatch(SET_BLANK_MAPS_ROOFS_SELECTOR());
    }
    this.map = null;

    // Re-enable PanelsEditor's keyboard handler for Design / editor modes.
    initKeyboard(false);
  }

  destroyMap = () => {
    this.tearDownMap(true);
  }

  // After re-initializing the map (e.g., returning from the editor), recreate
  // Google Maps polygons from the existing redux roofs so the user's marked
  // roofs survive the editor round-trip. Mirrors legacy
  // googleMapsRoofsSelector.loadRoofSelectorShapes.
  rehydrateRoofs = () => {
    const appState = state() as any;
    const roofs = appState && appState.drawingManager && appState.drawingManager.roofs;
    if (!roofs) return;
    Object.keys(roofs).forEach((roofId) => {
      const id = parseInt(roofId, 10);
      // Skip the lite seed roofs (id=0, or id=1 if at Albuquerque default).
      // They exist for canvas-mode bookkeeping and to keep autosave payloads
      // non-empty, but their coords are defaults — recreating them would drop
      // a phantom polygon unrelated to anything the user actually marked on
      // the satellite map.
      if (id === 0) return;
      const r = roofs[roofId];
      if (id === 1 && r && r.marker && r.marker.lat === 35.0844 && r.marker.lng === -106.6504) {
        return;
      }
      if (r && r.coords) {
        try {
          createRoofArea(r.coords, id);
          createLeadEdgesOnMap(id);
        } catch (_) { /* ignore */ }
      }
    });
    if (this.state.labelsHidden) {
      this.applyRoofLabelsVisibility(true);
    }
  }

  // ── Satellite keyboard / mouse events ──────────────────────────────
  // Mirrors roofsSelectorStage.ts but wraps deploy in try-catch so the
  // turf overlap-check exception doesn't abort finalization.

  private mapDblClickListener: any = null;

  bindSatelliteEvents = () => {
    document.addEventListener('keydown', this.onSatKeyDown);
    document.addEventListener('keyup', this.onSatKeyUp);
    document.addEventListener('mousedown', this.onSatMouseDown);
    // Bind dblclick directly on the Google Map — document-level dblclick
    // doesn't fire reliably because the Maps canvas swallows the event.
    const g = (window as any).google;
    if (this.map && g && g.maps) {
      this.mapDblClickListener = g.maps.event.addListener(this.map, 'dblclick', this.onSatDblClick);
    }
  }

  unbindSatelliteEvents = () => {
    document.removeEventListener('keydown', this.onSatKeyDown);
    document.removeEventListener('keyup', this.onSatKeyUp);
    document.removeEventListener('mousedown', this.onSatMouseDown);
    const g = (window as any).google;
    if (this.mapDblClickListener && g && g.maps && g.maps.event) {
      g.maps.event.removeListener(this.mapDblClickListener);
      this.mapDblClickListener = null;
    }
  }

  onSatKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Shift') {
      shiftDown();
    }
    if (e.key === 'Escape') {
      e.stopPropagation();
      e.preventDefault();
      this.safeDeployRoof(false);
    }
  }

  onSatKeyUp = (_e: KeyboardEvent) => {
    const appState = state() as any;
    if (appState.advanceRoofSelecting && appState.advanceRoofSelecting.tempPoint !== null) {
      reduxDispatch(CLEAR_TEMP_POINT());
    }
    shiftUp();
  }

  onSatDblClick = () => {
    const appState = state() as any;
    if (appState.advanceRoofSelecting && appState.advanceRoofSelecting.roofPoints.length > 1) {
      this.safeDeployRoof(true);
    }
  }

  onSatMouseDown = (e: MouseEvent) => {
    if (e.button === 2 || e.which === 3) {
      const appState = state() as any;
      const ars = appState.advanceRoofSelecting;
      if (ars && ars.enabled) {
        reduxDispatch(TOGGLE_ADVANCE_ROOF_DIMENSIONS());
        renderAdanvaceRoofSelecting();
        return;
      }
      this.toggleRoofLabels();
    }
  }

  toggleRoofLabels = () => {
    const roofs = getAllGoogleRoofObject() as any;
    if (!roofs || !Object.keys(roofs).length) return;
    const nextHidden = !this.state.labelsHidden;
    this.applyRoofLabelsVisibility(nextHidden);
    this.setState({ labelsHidden: nextHidden });
  }

  applyRoofLabelsVisibility = (hidden: boolean) => {
    const roofs = getAllGoogleRoofObject() as any;
    if (!roofs || !Object.keys(roofs).length) return;
    Object.keys(roofs).forEach((roofId) => {
      const entry = roofs[roofId];
      if (!entry) return;
      if (entry.infoWindow) {
        if (hidden) {
          entry.infoWindow.close();
        } else {
          entry.infoWindow.open(this.map);
        }
      }
      if (entry.azimuth && entry.azimuth.infoWindow) {
        if (hidden) {
          entry.azimuth.infoWindow.close();
        } else {
          entry.azimuth.infoWindow.open(this.map);
        }
      }
      if (entry.dimension) {
        setRoofDimensions(entry.dimension, hidden ? null : this.map);
      }
    });
  }

  /**
   * Finalize the in-progress polygon into a real Roof Area entity.
   *
   * We call `addNewRoofArea()` DIRECTLY instead of going through the
   * original's `deployAdvanceRoofSelecting()` chain, because that chain
   * hits `clearRoof()` → `distanceCheckFromFirstRoofCenter()` which
   * compares the new roof against the Lite-seeded default roof at
   * Albuquerque. If the user's project is elsewhere (>3 miles away),
   * the check blocks `addNewRoofArea` from ever being called.
   */
  safeDeployRoof = (dblClick: boolean) => {
    const appState = state() as any;
    const ars = appState.advanceRoofSelecting;
    if (!ars || !ars.enabled || !ars.roofPoints || ars.roofPoints.length < 3) return;

    const pixiLayer = getPixiLayer();
    if (!pixiLayer) return;

    // Copy points; remove the ghost double-click duplicate ONLY if the last
    // two points are identical (the Pixi overlay on Google Maps doesn't always
    // fire the two individual click events before the dblclick, so the ghost
    // point may not exist — removing unconditionally would drop a real vertex).
    let points = ars.roofPoints.slice(0);
    if (dblClick && points.length > 2) {
      const last = points[points.length - 1];
      const prev = points[points.length - 2];
      if (last.x === prev.x && last.y === prev.y) {
        points = points.slice(0, -1);
      }
    }

    // De-duplicate (same logic as advanceSelecting.ts)
    const unique: any[] = [];
    points.forEach((pt: any) => {
      if (!unique.find((p: any) => p.x === pt.x && p.y === pt.y)) {
        unique.push(pt);
      }
    });

    if (unique.length < 3) return;

    // Tracks whether we auto-opened the per-roof editor below. When we did,
    // the trailing tool reset must land on Add Panel (the editor's default
    // tool) instead of clearing the toolbar — otherwise marking a roof and
    // dropping straight into the editor leaves no tool selected.
    let enteredEditor = false;

    try {
      // Convert Pixi pixel coords → Google Maps LatLng
      const coords = unique.map((pt: any) => pixiLayer.fromPixelToLatLng(pt).toJSON());

      // Block if new roof overlaps an existing one.
      if (newRoofOverlaping(coords)) {
        clearGoogleAdvanceRoofSelecting(pixiLayer);
        turnGoogleMapsOnMapMoveControls();
        if (this.map) this.map.setOptions({ draggable: true });
        this.setState({ activeTool: null });
        return;
      }

      const newRoofId = addNewRoofArea(coords, unique);
      if (this.state.labelsHidden) {
        this.applyRoofLabelsVisibility(true);
      }
      // Auto-enter the per-roof editor for the new roof. The legacy flow
      // requires clicking the roof's center marker to fire goToPanelsEditor,
      // which gates entry on canGotoPanelsEditor() — a check designed for the
      // legacy projectDesign drawer (it opens OPEN_DRAWER_PAGE to surface
      // missing fields like shortest_building_length). Lite has no drawer UI,
      // so a failed check silently traps the user in roof-marking view with
      // the toolbar Add Panel button disabled. Two steps:
      //  1. Seed lead edge 0 (legacy onDeploy → setFirstDrawEdgeAsLeadEdge).
      //  2. Call goToGooglePanelsEditor → activeEditor → ACTIVE_PANELS_EDITOR,
      //     which is what sets background.selectedRoofId. We bypass the
      //     canGotoPanelsEditor gate by calling goToGooglePanelsEditor
      //     directly (the gate lives in roofsSelectorDrawingManager's
      //     goToPanelsEditor wrapper, not in the google-side function).
      if (typeof newRoofId === 'number') {
        const southMostIndex = findSouthMostEdgeIndex(coords);
        selectRoofLeadEdge({ edgeNumber: southMostIndex, roofId: newRoofId });
      }
    } catch (err) {
      // Guard: createRoofArea may throw if projection isn't stabilized yet.
    }

    // Clear drawing state (deferred 30ms internally).
    clearGoogleAdvanceRoofSelecting(pixiLayer);

    // Restore map navigation and deactivate the tool (matches original
    // UBuilder where Draw Shape un-highlights after Escape). When we auto-
    // opened the per-roof editor, select Add Panel — the editor's default
    // tool — instead of clearing the toolbar, so the user can start placing
    // panels immediately. Deferred to a microtask so it runs AFTER the
    // synchronous componentDidUpdate (enteredEditor branch) that react-redux
    // fires during goToGooglePanelsEditor — otherwise that update's
    // selectTool('addpanel') would be clobbered by this trailing reset.
    turnGoogleMapsOnMapMoveControls();
    if (this.map) {
      this.map.setOptions({ draggable: true });
    }
    if (enteredEditor) {
      setTimeout(() => this.selectTool('addpanel'), 0);
    } else {
      this.setState({ activeTool: null });
    }
  }

  // ── Keyboard shortcuts ─────────────────────────────────────────────

  handleKeyDown = (e: KeyboardEvent) => {
    const target = e.target as HTMLElement | null;
    if (target) {
      const tag = target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable) {
        return;
      }
    }
    if (e.key === 'Escape' && this.state.activeTool === 'select' && this.state.moveMode) {
      e.preventDefault();
      e.stopPropagation();
      this.cancelMove();
      return;
    }
    const mod = e.ctrlKey || e.metaKey;
    if (!mod) return;
    const key = e.key.toLowerCase();
    if (key === 'z' && !e.shiftKey) {
      e.preventDefault();
      this.handleUndo();
    } else if ((key === 'z' && e.shiftKey) || key === 'y') {
      e.preventDefault();
      this.handleRedo();
    }
  }

  // ── Tool selection ─────────────────────────────────────────────────

  handleToolSelect = (tool: string) => {
    if (tool === 'addpanel') {
      this.setState({ addPanelInitialTooltipDismissed: true });
    }
    if (tool === 'addpanel' && this.state.activeTool === tool && getPanels().length === 0) {
      showV3ToolGuidance(tool, this.getNumericProductId());
      return;
    }
    if (tool === 'markroof') {
      this.setState({ markRoofInitialTooltipDismissed: true });
    }

    const newTool = this.state.activeTool === tool ? null : tool;
    this.selectTool(newTool);
    showV3ToolGuidance(newTool, this.getNumericProductId());
  }

  // Force-select a tool, bypassing handleToolSelect's toggle behaviour.
  // Used to make Add Panel the default tool when a roof or blank design opens.
  selectTool = (newTool: string | null) => {
    const appState = state() as any;
    const moveArrayEnabled = !!(appState.background && appState.background.moveArrayMode);

    this.setState({ activeTool: newTool });
    if (newTool !== 'addpanel' && newTool !== 'markroof') {
      dismissV3ToolGuidance();
    }

    // Deactivate roof drawing when switching away from markroof.
    if (newTool !== 'markroof') {
      reduxDispatch(TURN_OFF_ROOF_SELECTING());
    }
    // Disable Navigate Map mode when selecting a different tool.
    if (this.state.navigateMode) {
      this.setState({ navigateMode: false });
      turnGoogleMapsOffMapMoveControls();
      if (this.map) this.map.setOptions({ draggable: false });
    }

    // Reset every legacy editor mode first. The Lite ribbon keeps its own
    // activeTool state, while PanelsEditor still acts on Redux flags such as
    // rubberBand.mode, measurementTool.enabled, and creatingBlocked. Leaving
    // any previous flag behind makes the highlighted ribbon button disagree
    // with what the canvas actually does when switching Remove/Select/Measure.
    reduxDispatch(MOVE_MAP_MODE_DISABLE());
    if (moveArrayEnabled) {
      reduxDispatch(RESTORE_PANELS_FOR_NO_MOVEMENT());
    }
    reduxDispatch(MOVE_ARRAY_MODE_DISABLE());
    reduxDispatch(TOGGLE_ATTACHMENTS_DISABLE());
    reduxDispatch(DISABLE_BAYS_CONTAINER());
    reduxDispatch(TURN_OFF_MEASUREMENT_TOOL());
    reduxDispatch(RESET_RUBBERBAND_STATE());
    reduxDispatch(DISABLE_RUBBER_BAND());
    reduxDispatch(BLOCK_CREATING_PANEL());
    if (newTool !== 'markroof' && newTool !== 'addobs') {
      reduxDispatch(TERMINATE_ADVANCE_ROOF_SELECTING());
    }

    if (newTool !== 'select') {
      this.clearSelection(false);
    }

    switch (newTool) {
      case 'addpanel':
        reduxDispatch(SET_DRAW_RUBBER_BAND());
        reduxDispatch(UNBLOCK_CREATING_PANEL());
        reduxDispatch(SHOW_CURSOR());
        break;
      case 'removepanel':
        reduxDispatch(SET_REMOVE_RUBBER_BAND());
        reduxDispatch(UNBLOCK_CREATING_PANEL());
        reduxDispatch(HIDE_CURSOR());
        break;
      case 'markroof':
        // Defensively drop any leftover legacy document listeners (notably
        // dblclick.roofsSelectorStage, added by initKeyboard when entering a
        // per-roof editor). If one survived the editor→markroof transition it
        // would treat the double-click that finalizes this roof as an
        // obstruction-deploy → ADD_OBSTRUCTION → REMOVE_PANELS, spuriously
        // dirtying the project and reloading the BOM.
        clearLegacyStageEvents();
        // Wire into the ORIGINAL UBuilder's advance-roof-selecting system.
        reduxDispatch(TURN_ON_ROOF_SELECTING());
        // Mark Roof needs map dragging disabled (drawing, not panning).
        turnGoogleMapsOffMapMoveControls();
        if (this.map) this.map.setOptions({ draggable: false });
        reduxDispatch(HIDE_CURSOR());
        break;
      case 'move':
        reduxDispatch(MOVE_MAP_MODE_ENABLE());
        reduxDispatch(HIDE_CURSOR());
        break;
      case 'measure':
        reduxDispatch(DISABLE_RUBBER_BAND());
        reduxDispatch(TURN_ON_MEASUREMENT_TOOL());
        reduxDispatch(HIDE_CURSOR());
        break;
      case 'fillarea':
        reduxDispatch(DISABLE_RUBBER_BAND());
        reduxDispatch(HIDE_CURSOR());
        this.handleFillArea();
        // Fill Area is a one-shot action, not a persistent tool mode.
        this.setState({ activeTool: null });
        break;
      case 'addobs':
        reduxDispatch(DISABLE_RUBBER_BAND());
        reduxDispatch(HIDE_CURSOR());
        reduxDispatch(BLOCK_CREATING_PANEL());
        reduxDispatch(TURN_ON_ROOF_SELECTING());
        break;
      case 'removeobs':
        reduxDispatch(DISABLE_RUBBER_BAND());
        reduxDispatch(HIDE_CURSOR());
        reduxDispatch(BLOCK_CREATING_PANEL());
        break;
      case 'select':
        reduxDispatch(DISABLE_RUBBER_BAND());
        reduxDispatch(BLOCK_CREATING_PANEL());
        reduxDispatch(HIDE_CURSOR());
        break;
      default:
        reduxDispatch(HIDE_CURSOR());
        break;
    }
  }

  // Remove Obstruction: on canvas click, hit-test obstruction polygons and remove.
  // Uses a ray-casting point-in-polygon check against the obstruction coords
  // from Redux (offset by canvasCenter to match cursor coordinate space).
  handleRemoveObsClick = (_e: MouseEvent) => {
    if (this.state.activeTool !== 'removeobs') return;
    const appState = state() as any;
    const selectedRoofId = appState.background && appState.background.selectedRoofId;
    if (selectedRoofId === null || selectedRoofId === undefined) return;
    const obsByRoof = appState.obstructions && appState.obstructions.obstructions && appState.obstructions.obstructions[selectedRoofId];
    if (!obsByRoof) return;
    const pos = appState.editorCursor && appState.editorCursor.position;
    if (!pos) return;
    const center = appState.settings && appState.settings.canvasCenter;
    if (!center) return;

    const obsIds = Object.keys(obsByRoof);
    for (let i = obsIds.length - 1; i >= 0; i--) {
      const obs = obsByRoof[obsIds[i]];
      if (!obs || !obs.coords || obs.coords.length < 3) continue;
      // Offset coords by canvasCenter to match cursor coordinate space.
      const poly = obs.coords.map((c: any) => ({ x: c.x + center.x, y: c.y + center.y }));
      if (this.pointInPolygon(pos.x, pos.y, poly)) {
        reduxDispatch(REMOVE_OBSTRUCTION(selectedRoofId, Number(obsIds[i])));
        break;
      }
    }
  }

  // Ray-casting point-in-polygon test.
  private pointInPolygon(px: number, py: number, poly: { x: number; y: number }[]): boolean {
    let inside = false;
    for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      const xi = poly[i].x, yi = poly[i].y;
      const xj = poly[j].x, yj = poly[j].y;
      if ((yi > py) !== (yj > py) && px < (xj - xi) * (py - yi) / (yj - yi) + xi) {
        inside = !inside;
      }
    }
    return inside;
  }

  handleOrientationChange = (orient: 'portrait' | 'landscape') => {
    if (orient !== readReduxOrientation()) {
      reduxDispatch(FLIP_CURSOR());
      reduxDispatch(CHANGE_PANELS_SIZES());
      this.setState({ orientation: orient });
    }
  }

  // After restoring a panels snapshot from history, the collision R-tree
  // still holds bounds for panels that were undone (and is missing bounds
  // for panels that came back via redo) because LOAD_PANELS_FROM_HISTORY
  // only swaps the array — it doesn't maintain the spatial index. Without
  // this rebuild, those phantom bounds block new panels from being drawn
  // over the freshly-empty positions until "Clear All" calls resetRTree.
  // Mirrors the reset+restore pattern from panelsEditorDidUpdate.ts.
  rebuildPanelsRTreeForLite = () => {
    const s = state() as any;
    const rowSpacing = (s.settings && s.settings.rowSpacing) || 0;
    const columnSpacing = (s.settings && s.settings.columnSpacing) || 0;
    const metersPerPixel = (s.background && s.background.metersPerPixel) || 0;
    resetRTree();
    if (metersPerPixel > 0) {
      reduxDispatch(RESTORE_PANELS_COLLISIONS_BOUNDS(rowSpacing, columnSpacing, metersPerPixel));
    }
  }

  handleUndo = () => {
    // Lite reads from its own corrected history slice (`liteHistory`) so
    // the legacy `history` slice stays untouched. The middleware writes
    // to `liteHistory` whenever isUbuilderLite is true.
    const { liteHistory: historyState } = state() as any;
    if (historyState && historyState.canUndo) {
      reduxDispatch(LITE_UNDO_HISTORY());
      const appState = state() as any;
      reduxDispatch(LOAD_PANELS_FROM_HISTORY(appState.liteHistory.panelsSnapshot[appState.liteHistory.index], appState.settings.rowSpacing, appState.settings.columnSpacing, appState.background.metersPerPixel));
      this.rebuildPanelsRTreeForLite();
    }
  }

  handleRedo = () => {
    const { liteHistory: historyState } = state() as any;
    if (historyState && historyState.canRedo) {
      reduxDispatch(LITE_REDO_HISTORY());
      const appState = state() as any;
      reduxDispatch(LOAD_PANELS_FROM_HISTORY(appState.liteHistory.panelsSnapshot[appState.liteHistory.index], appState.settings.rowSpacing, appState.settings.columnSpacing, appState.background.metersPerPixel));
      this.rebuildPanelsRTreeForLite();
    }
  }

  handleClearAll = () => {
    this.setState({ clearAllConfirmOpen: true });
  }

  cancelClearAll = () => {
    this.setState({ clearAllConfirmOpen: false });
  }

  confirmClearAll = () => {
    this.setState({ clearAllConfirmOpen: false });
    this.clearSelection(false);
    deleteAllPanels();
    const clearPid = this.getNumericProductId();
    if (clearPid && (isNxtHorizon(clearPid) || isSolarMount(clearPid))) {
      reduxDispatch(SET_PORTRAIT_CURSOR());
      this.setState({ orientation: 'portrait' });
    }
    // deleteAllPanels dispatches RESET_PANELS_STATE, which liteDirtyMiddleware
    // intentionally excludes (it also fires on editor unmount). Mark dirty
    // explicitly so the next autosave tick picks up the cleared state.
    reduxDispatch(MARK_LITE_DIRTY());
    // Wipe BOM immediately so the right panel doesn't keep showing the
    // previous parts/accessories/attachment rows (with zero quantities) while
    // the next autosave PUT is in flight. The autosave epic also skips
    // re-fetching BOM when there are zero panels.
    reduxDispatch(BOM_RESET());
    clearBomEditCache(this.props.projectId);
  }

  handleFillArea = () => {
    const s = state() as any;
    const productId = s.projectConfiguration.productId;
    const points = getRoofEdgesCoords();
    if (points !== null) {
      let panels;
      if (isGFT(productId)) {
        panels = drawGftPanelsInTables('SE', points, createPanel, nextUid());
      } else if (isAscender(productId)) {
        panels = drawAscenderPanelsInTables('SE', points, createPanel, nextUid());
      } else if (isULA(productId)) {
        panels = drawUlaPanelsInTables('SE', points, createPanel, nextUid());
      } else if (productId === 15) {
        panels = draw_double_panels_on_area('SE', points, createPanel, nextUid());
      } else {
        panels = draw_on_area('SE', points, createPanel, nextUid());
      }
      reduxDispatch(REQUEST_ADD_PANELS(panels));
    }
  }

  handleUnitChange = (unit: string) => {
    this.setState({ unitMode: unit as 'Imperial' | 'Metric' });
  }

  handleViewModeToggle = () => {
    this.setState({ pendingViewSwitch: true });
  }

  // Exit per-roof panels editor sub-mode (satellite only). Mirrors legacy's
  // back-out flow: clears selectedRoofId / cords / roofEdges so the satellite
  // map re-renders with all marked roofs preserved.
  handleBackToRoofs = () => {
    savePanelsEditor();
    // Unmount PanelsEditor before DEACTIVE_PANELS_EDITOR nulls background.cords.
    // Without this guard the connected editor can read null coords during the
    // same React commit and leave the center panel blank until a hard refresh.
    this.setState({ switchingView: true, activeTool: null }, () => {
      reduxDispatch(DEACTIVE_PANELS_EDITOR());
      reduxDispatch(TERMINATE_ADVANCE_ROOF_SELECTING());
      requestAnimationFrame(() => {
        if (!this.isUnmounted) {
          this.setState({ switchingView: false });
        }
      });
    });
  }

  handlePanelsCleared = () => {
    if (this.state.viewMode === 'satellite' && this.map) {
      this.pendingRehydrate = true;
      setTimeout(() => this.initMap(), 0);
    }
  }

  cancelViewSwitch = () => {
    this.setState({ pendingViewSwitch: false });
  }

  confirmViewSwitch = () => {
    const goingToSatellite = this.state.viewMode === 'canvas';
    this.clearSelection(false);

    const s = state() as any;
    let currentPitch = s && s.tiltedRoof && s.tiltedRoof.roofPitch;

    const pid = this.getNumericProductId();
    if (currentPitch === '---' && pid && (isSMFlushOrTiltOrTiltPR(pid) || isNxtHorizon(pid))) {
      currentPitch = getDefaultRoofPitchValue(pid, 1, 1, undefined, true);
    }

    if (!goingToSatellite) {
      reduxDispatch(TERMINATE_ADVANCE_ROOF_SELECTING());
      this.setState({ activeTool: null });
    }

    // Bug fix: Force PanelsEditor to unmount BEFORE we clear background state.
    // Without this, dispatching DEACTIVE_PANELS_EDITOR / CLEAR_BACKGROUND_REDUCER
    // nulls background.cords while PanelsEditor is still mounted — its
    // Redux-connected componentDidUpdate fires and tries to read cords.lat,
    // causing "Cannot read properties of null (reading 'lng')".
    // Setting switchingView=true makes the render skip PanelsEditor immediately.
    this.setState({ switchingView: true }, () => {
      // Callback fires after React has unmounted PanelsEditor. Safe to wipe.
      this.performViewSwitch(goingToSatellite, currentPitch);
    });
  }

  private performViewSwitch = (goingToSatellite: boolean, preservedPitch?: string) => {
    // Symmetric full wipe. Both directions discard the prior design and
    // start fresh.
    deleteAllPanels();
    reduxDispatch(CLEAR_OBSTRUCTIONS());
    reduxDispatch(DEACTIVE_PANELS_EDITOR());
    reduxDispatch(CLEAR_BACKGROUND_REDUCER());
    reduxDispatch(RESET_DRAWING_MANAGER());

    if (preservedPitch) {
      reduxDispatch(SET_TILTED_ROOF(preservedPitch));
    }

    if (goingToSatellite) {
      // Canvas → Satellite: flip mapType synchronously so the very next
      // autosave sees mapType='google' and writes map_type=1.
      // Do NOT seed a default roof (id=1) here — doing so blocks the map from
      // centering on the project's lat/lng, and rehydrateRoofs would draw a
      // phantom Albuquerque roof over the satellite map.
      reduxDispatch(SET_DEFAULT_MAP_ROOFS_SELECTOR());
    } else {
      // Satellite → Canvas: re-seed a fresh default canvas roof so
      // PanelsEditor has something to render and the autosave payload
      // includes a valid roof shell. SM/NXT reuse the new-project dummy
      // roof edges so the unplaced cursor stays yellow.
      const switchPid = this.getNumericProductId();
      const isSmOrNxt = !!(switchPid && (isNxtHorizon(switchPid) || isSolarMount(switchPid)));
      if (isSmOrNxt) {
        reduxDispatch(SET_PORTRAIT_CURSOR());
        // Same colour as a fresh SM/NXT blank-map project: unplaced cursor is
        // yellow (roof-zone 1) until the module is placed.
        reduxDispatch(SET_YELLOW_CURSOR());
        this.setState({ orientation: 'portrait' });
      }
      reduxDispatch(SET_BLANK_MAPS_ROOFS_SELECTOR());
      reduxDispatch(SET_METERS_PER_PIXEL(0.1));
      // Read building dimensions for commercial products before seeding.
      const switchEnv = ((state() as any).projectConfiguration || {}).projectEnvConfig || {};
      const switchBLen = (switchPid && isCommercialProduct(switchPid)) ? (Number(switchEnv.building_length) || 20) : 0;
      const switchSLen = (switchPid && isCommercialProduct(switchPid)) ? (Number(switchEnv.shortest_building_length) || 20) : 0;
      const defaultRoof: any = {
        id: 1,
        roofPitch: preservedPitch || getDefaultRoofPitchValue(switchPid, Number(switchEnv.building_code) || 1, Number(switchEnv.building_type) || 1, undefined, true),
        structureTilt: null,
        tableRowSpacing: undefined,
        panels: null,
        metersPerPixel: 0.1,
        marker: { lat: 35.0844, lng: -106.6504 },
        coords: [
          { lat: 35.0846, lng: -106.6506 },
          { lat: 35.0846, lng: -106.6502 },
          { lat: 35.0842, lng: -106.6502 },
          { lat: 35.0842, lng: -106.6506 },
        ],
        roofName: 'Roof 1',
        bgOffset: { x: 0, y: 0 },
        bgRotation: 0,
        skewEdgesPixiCords: null,
        panelsRotationDegrees: 0,
        lowEdgeToRoof: 50,
        exposureRecaluclationHash: null,
        panelBayMapping: new Map(),
        isConfirmedYesorNo: false,
      };
      reduxDispatch(LOAD_ROOFS_FROM_API({ 1: defaultRoof } as any));
      reduxDispatch(SELECT_ROOF_LEAD_EDGE(0, 1));
      // Same dummy roof edges a reopened Lite canvas uses. An empty outline
      // makes the panel setback non-finite, which is saved as null and leaves
      // module_array empty, so the BOM is not generated.
      // Include building dims so the reducer doesn't reset them to 0 (causes FogOfWar grey overlay).
      reduxDispatch(ACTIVE_PANELS_EDITOR(
        defaultRoof.marker,
        defaultRoof.coords,
        1,
        undefined,
        switchBLen,
        switchSLen,
      ));
    }

    reduxDispatch(MARK_LITE_DIRTY());
    // Satellite ↔ blank discards the prior design. Wipe the in-memory BOM
    // and accessory qty overlays so the right panel doesn't keep the previous
    // array's quantities (Qty ≠ Suggested) until a full reload.
    reduxDispatch(BOM_RESET());
    clearBomEditCache(this.props.projectId);
    // Bump editorKey so PanelsEditor truly unmounts and remounts fresh.
    // Also clear switchingView so PanelsEditor can mount again.
    this.setState((prev) => ({
      viewMode: prev.viewMode === 'canvas' ? 'satellite' : 'canvas',
      navigateMode: false,
      pendingViewSwitch: false,
      switchingView: false,
      editorKey: prev.editorKey + 1,
    }));

    // Persist the wiped state immediately.
    const { projectId, liteUpdating } = this.props;
    if (projectId && !liteUpdating) {
      reduxDispatch(UPDATE_LITE_PROJECT_REQUEST({ projectId }));
    }
  }

  handleNavigateToggle = () => {
    const entering = !this.state.navigateMode;
    this.setState({ navigateMode: entering, activeTool: entering ? null : this.state.activeTool });
    if (entering) {
      // Deactivate any active tool and enable map dragging
      reduxDispatch(TURN_OFF_ROOF_SELECTING());
      reduxDispatch(MOVE_MAP_MODE_ENABLE());
      reduxDispatch(HIDE_CURSOR());
      reduxDispatch(DISABLE_RUBBER_BAND());
      reduxDispatch(TURN_OFF_MEASUREMENT_TOOL());
      turnGoogleMapsOnMapMoveControls();
      if (this.map) this.map.setOptions({ draggable: true });
    } else {
      // Disable map dragging, restore panel editing
      turnGoogleMapsOffMapMoveControls();
      if (this.map) this.map.setOptions({ draggable: false });
      reduxDispatch(MOVE_MAP_MODE_DISABLE());
    }
  }

  // Two zoom modes share these handlers because the +/− buttons render in
  // both sub-views (satellite Mark Roof + design-mode Pixi canvas):
  //   - Satellite/Mark Roof: this.map is live → drive Google Maps zoom;
  //     map's 'zoom_changed' listener updates this.state.zoom for the label.
  //   - Design mode (selectedRoofId set): this.map was nulled by
  //     tearDownMap on roof-enter, and PanelsEditor's Pixi stage owns the
  //     canvas. Route through the shared zoom() in zoom.ts (same pattern as
  //     legacy panelsEditorControls.tsx), which scales stage.scale and
  //     dispatches SET_STAGE_SCALE.
  handleZoomIn = () => {
    if (this.props.selectedRoofId != null) {
      pixiZoom({ deltaY: -1 } as any, getStage(), getRenderer());
      return;
    }
    this.setState((prev) => {
      const next = Math.min(prev.zoom + 1, MAX_ZOOM);
      if (this.map) this.map.setZoom(next);
      return { zoom: next };
    });
  }

  handleZoomOut = () => {
    if (this.props.selectedRoofId != null) {
      pixiZoom({ deltaY: 1 } as any, getStage(), getRenderer());
      return;
    }
    this.setState((prev) => {
      const next = Math.max(prev.zoom - 1, MIN_ZOOM);
      if (this.map) this.map.setZoom(next);
      return { zoom: next };
    });
  }

  handleToggleLeftPanel = () => {
    this.setState((prev) => ({ leftPanelCollapsed: !prev.leftPanelCollapsed }));
  }

  handleToggleRightPanel = () => {
    this.setState((prev) => ({ rightPanelCollapsed: !prev.rightPanelCollapsed }));
  }

  handleDomesticToggle = () => {
    // Backend stores domestic_content as PositiveSmallIntegerField with
    // YES_OR_NO choices (0/1) — DRF rejects boolean true/false.
    // SET_PROJECT_OPTION updates Redux but does not persist; without an
    // immediate PUT, a same-session navigation that triggers a project GET
    // (e.g. back to /lite/dashboard then opening another route, or to the
    // CompleteBomPage and back) overwrites the in-flight value with the
    // stale server copy. regenBom:true also wipes user_builds and chains
    // a GET /bom so the parts list + prices reflect the new flag without
    // waiting on the 5s autosave tick.
    const { dispatch, domesticContent, projectId } = this.props;
    if (!dispatch) return;
    const turningOn = !domesticContent;
    const numericProductId = this.getNumericProductId();
    // Ascender rail clamps are decoupled from domestic content — toggling DC
    // should not trigger the SM clamp-change confirmation flow or delete any
    // panels. Only the non-ascender SolarMount family couples DC with clamps.
    if (numericProductId && isSolarMount(numericProductId) && !isSMAscenderFlush(numericProductId)) {
      // When turning DC on and both clamps are already Standard, the clamps
      // are exactly what DC requires — no clamp change is needed, so skip the
      // panel/BOM-deleting confirmation flow and just flip the DC flag.
      if (turningOn) {
        const env = ((state() as any).projectConfiguration || {}).projectEnvConfig || {};
        const mid = Number(env.mid_clamps_choices);
        const end = Number(env.end_clamps_choices);
        if (mid === MidEndClampChoice.STANDARD_CLAMP && end === MidEndClampChoice.STANDARD_CLAMP) {
          dispatch(SET_PROJECT_OPTION('domestic_content', 1));
          dispatch(SET_PROJECT_OPTION('is_domestic_mlpe_required', 1));
          dispatch(SET_PROJECT_OPTION('allow_north_bays', 0));
          if (projectId && !this.props.liteUpdating) {
            dispatch(UPDATE_LITE_PROJECT_REQUEST({ projectId, regenBom: true }));
          }
          return;
        }
      }
      const clampValue = turningOn ? MidEndClampChoice.STANDARD_CLAMP : MidEndClampChoice.UNIVERSAL_CLAMP;
      this.setState((prev) => ({
        advancedForceOpenSignal: prev.advancedForceOpenSignal + 1,
        domesticClampTarget: clampValue,
        pendingDomesticTurningOn: turningOn,
      }));
      return;
    }
    dispatch(SET_PROJECT_OPTION('domestic_content', turningOn ? 1 : 0));
    dispatch(SET_PROJECT_OPTION('is_domestic_mlpe_required', turningOn ? 1 : 0));
    dispatch(SET_PROJECT_OPTION('allow_north_bays', turningOn ? 0 : 1));
    if (projectId && !this.props.liteUpdating) {
      dispatch(UPDATE_LITE_PROJECT_REQUEST({ projectId, regenBom: true }));
    }
  }

  onDomesticClampResolved = (confirmed: boolean) => {
    const { dispatch, projectId } = this.props;
    const turningOn = this.state.pendingDomesticTurningOn;
    this.setState({ domesticClampTarget: null, pendingDomesticTurningOn: null });
    if (confirmed && turningOn !== null) {
      dispatch(SET_PROJECT_OPTION('domestic_content', turningOn ? 1 : 0));
      dispatch(SET_PROJECT_OPTION('is_domestic_mlpe_required', turningOn ? 1 : 0));
      dispatch(SET_PROJECT_OPTION('allow_north_bays', turningOn ? 0 : 1));
    }
    if (projectId && !this.props.liteUpdating) {
      dispatch(UPDATE_LITE_PROJECT_REQUEST({ projectId, regenBom: true }));
    }
  }

  onSwitchDomesticOff = () => {
    const { dispatch, projectId } = this.props;
    this.setState({ domesticClampTarget: null });
    dispatch(SET_PROJECT_OPTION('domestic_content', 0));
    dispatch(SET_PROJECT_OPTION('is_domestic_mlpe_required', 0));
    dispatch(SET_PROJECT_OPTION('allow_north_bays', 1));
    if (projectId && !this.props.liteUpdating) {
      dispatch(UPDATE_LITE_PROJECT_REQUEST({ projectId, regenBom: true }));
    }
  }

  hydrateCurrentProfile = (): void => {
    if (this.state.currentProfileId !== null && this.state.currentProfileName !== null) return;
    const vars = this.props.projectVariables || {};
    const raw = vars.profile_id;
    if (raw === null || raw === undefined || raw === '') return;
    const idNum = typeof raw === 'number' ? raw : Number(raw);
    if (isNaN(idNum)) return;
    const profiles: UserProfile[] = Array.isArray(this.props.userProfiles) ? this.props.userProfiles : [];
    const match = profiles.find((p) => p && typeof p.id === 'number' && p.id === idNum);
    if (!match) return;
    this.setState({ currentProfileId: idNum, currentProfileName: match.title || null });
  }

  openSaveProfile = () => {
    const numericProductId = this.getNumericProductId();
    if (!numericProductId) return;
    const defaultName = this.state.currentProfileName || this.getDefaultProfileName() || '';
    this.setState({ saveProfileOpen: true, saveProfileName: defaultName });
  }

  closeSaveProfile = () => {
    this.setState({ saveProfileOpen: false, saveProfileName: '' });
  }

  onSaveProfileNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ saveProfileName: e.target.value });
  }

  onSaveProfileKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.confirmSaveProfile();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      this.closeSaveProfile();
    }
  }

  getNumericProductId = (): number | null => {
    const { numericProductId, productId } = this.props;
    if (typeof numericProductId === 'number' && numericProductId > 0) {
      return numericProductId;
    }
    if (productId && (products as any)[productId]) {
      return (products as any)[productId];
    }
    const s = state() as any;
    const fromStore = s && s.projectConfiguration && s.projectConfiguration.productId;
    return typeof fromStore === 'number' ? fromStore : null;
  }
  private getDefaultProfileName = (): string => {
    const productId = this.getNumericProductId();
    if (!productId) return '';
    const productName = getLiteProductLabel(productId);
    return productName ? `${productName} - ` : '';
  };
  
  buildProfilePreviewTags = (): string[] => {
    const { mfgs, models, selectedMfgId, selectedModelId, modelData } = this.props;
    const s = state() as any;
    const env = (s && s.projectConfiguration && s.projectConfiguration.projectEnvConfig) || {};
    const tags: string[] = [];
    if (env.system_code) tags.push(env.system_code);
    const mfgName = (mfgs || []).find((m) => m && m.id === selectedMfgId);
    const modelName = (models || []).find((m) => m && m.id === selectedModelId);
    if (mfgName) tags.push(mfgName.name);
    if (modelName) tags.push(modelName.name);
    else if (modelData && modelData.name) tags.push(modelData.name);
    if (env.rail_direction) tags.push(env.rail_direction);
    if (env.preferred_span) tags.push(`Span: ${env.preferred_span}"`);
    if (env.rafter_spacing_inches) tags.push(`Rafter: ${env.rafter_spacing_inches}"`);
    return tags;
  }

  confirmSaveProfile = () => {
    const { dispatch, mfgs, models, selectedMfgId, selectedModelId, modelData } = this.props;
    const name = this.state.saveProfileName.trim();
    if (!name || !dispatch) return;
    const numericProductId = this.getNumericProductId();
    if (!numericProductId) return;
    const s = state() as any;
    const env = (s && s.projectConfiguration && s.projectConfiguration.projectEnvConfig) || {};
    const ms = (s && s.moduleSelector) || {};
    const reduxMfgId = typeof ms.selectedMfgId === 'number' ? ms.selectedMfgId : null;
    const reduxModelId = typeof ms.selectedModelId === 'number' ? ms.selectedModelId : null;
    const toNumOrNull = (v: any): number | null => {
      if (typeof v === 'number' && !isNaN(v)) return v;
      if (v === null || v === undefined || v === '') return null;
      const n = Number(v);
      return isNaN(n) ? null : n;
    };
    const effectiveMfgId = (typeof selectedMfgId === 'number' ? selectedMfgId : null)
      ?? reduxMfgId
      ?? toNumOrNull(env.module_id)
      ?? toNumOrNull(env.module);
    const effectiveModelId = (typeof selectedModelId === 'number' ? selectedModelId : null)
      ?? reduxModelId
      ?? toNumOrNull(env.model_id)
      ?? toNumOrNull(env.model);
    const mfgList = (mfgs && mfgs.length ? mfgs : ms.mfgs) || [];
    const modelList = (models && models.length ? models : ms.models) || [];
    const mfg = mfgList.find((m: any) => m && m.id === effectiveMfgId);
    const model = modelList.find((m: any) => m && m.id === effectiveModelId);
    const md = (modelData && Object.keys(modelData).length ? modelData : ms.modelData) || {};
    const widthIn = toNumOrNull(env.module_width) ?? toNumOrNull(md.width) ?? 0;
    const lengthIn = toNumOrNull(env.module_length) ?? toNumOrNull(md.height) ?? 0;
    const modelSpecs = {
      output: toNumOrNull(env.module_watts) ?? toNumOrNull(md.watts) ?? 0,
      widthIn,
      lengthIn,
      thicknessIn: toNumOrNull(env.module_thickness) ?? toNumOrNull(md.thickness) ?? 0,
      weightLbs: toNumOrNull(env.module_weight) ?? toNumOrNull(md.weight) ?? 0,
      areaFt: widthIn && lengthIn ? (widthIn * lengthIn) / 144 : 0,
    };
    const roofRaw = env.roof_type ?? env.roofType ?? env.roof;
    const drawingRoofs = (s && s.drawingManager && s.drawingManager.roofs) || {};
    const firstRoofKey = Object.keys(drawingRoofs)[0];
    const firstRoof = firstRoofKey !== undefined ? (drawingRoofs[firstRoofKey] || {}) : {};
    // Resolve roof_pitch to its integer form here (matching liteProjectActions
    // buildLiteUpdatePayload). drawingManager.roofs[0].roofPitch may hold
    // "N/12" labels (ROOF_PITCH maps them to ROOF_PITCH_CHOICE ints) or degree
    // strings like "14" (Lite's AdvancedSection dropdown uses degree values).
    // Degree strings are not keys in ROOF_PITCH, so fall back to Number() to
    // avoid zeroing out a valid pitch — mirrors buildLiteUpdatePayload.
    let roofPitchInt: number | null = null;
    if (typeof env.roof_pitch === 'number') {
      roofPitchInt = env.roof_pitch;
    } else if (typeof env.roof_pitch === 'string' && (ROOF_PITCH as any)[env.roof_pitch] !== undefined) {
      roofPitchInt = (ROOF_PITCH as any)[env.roof_pitch];
    } else if (typeof firstRoof.roofPitch === 'string') {
      roofPitchInt = (ROOF_PITCH as any)[firstRoof.roofPitch]
        ?? (isNaN(Number(firstRoof.roofPitch)) ? 0 : Number(firstRoof.roofPitch));
    } else if (typeof firstRoof.roofPitch === 'number') {
      roofPitchInt = firstRoof.roofPitch;
    }
    const advancedConfig: any = {
      building_height: env.building_height ?? null,
      roof_pitch: roofPitchInt,
      shortest_building_length: env.shortest_building_length ?? null,
      block_weight: env.block_weight ?? null,
      attachment_config: env.attachment_config ?? null,
      stagger_attachments: typeof env.stagger_attachments === 'boolean' ? env.stagger_attachments : null,
      rail_direction: env.rail_direction ?? null,
      rafter_spacing_inches: env.rafter_spacing_inches ?? null,
      preferred_span: env.preferred_span ?? null,
    };
    const augmentedProjectConfig = { ...env };
    Object.keys(advancedConfig).forEach((k) => {
      const v = advancedConfig[k];
      if (v !== null && v !== undefined && (augmentedProjectConfig[k] === null || augmentedProjectConfig[k] === undefined)) {
        augmentedProjectConfig[k] = v;
      }
    });
    const profile = buildUserProfilePayload({
      productId: numericProductId,
      title: name,
      projectConfig: augmentedProjectConfig,
      systemKey: env.system_key,
      systemCode: env.system_code,
      systemLabel: env.system_label,
      systemType: env.system_type,
      selectedMfgId: effectiveMfgId,
      selectedModelId: effectiveModelId,
      mfgName: mfg ? mfg.name : (env.module_manufacturer || md.mfg_name || null),
      modelName: model ? model.name : (env.module_model || md.name || null),
      modelSpecs,
      selectedRoof: roofRaw !== undefined && roofRaw !== null && roofRaw !== '' ? String(roofRaw) : null,
    });
    profile.project_config.advanced_settings = advancedConfig;
    const { currentProfileId, currentProfileName } = this.state;
    const isUpdate = currentProfileId !== null
      && currentProfileName !== null
      && name === currentProfileName;
    if (isUpdate) {
      dispatch(UPDATE_USER_PROFILE_REQUEST({ profileId: currentProfileId as number, profile }));
      showSuccessAlert(`Profile ${name} was updated successfully!`);
    } else {
      // Track the title used in this request so the lastCreatedProfile prop
      // update (driven by SAVE_USER_PROFILE_SUCCESS) can be matched to it
      // and trigger the follow-up profile_id ProjectVariable write.
      this.setState({ pendingCreateProfileTitle: name });
      dispatch(SAVE_USER_PROFILE_REQUEST({ profile, projectId: this.props.projectId }));
      showSuccessAlert(`Profile ${name} was created successfully!`);
    }
    this.closeSaveProfile();
  }

  // ── Select tool helpers ────────────────────────────────────────────

  setOverlayRef = (el: HTMLDivElement | null) => {
    this.overlayRef = el;
  }

  clearSelection = (clearError: boolean = true) => {
    if (this.state.moveMode) {
      this.cancelMove();
    }
    const hasSelection = this.state.selectedPanelIds.length > 0 || this.state.selectedObstructionIds.length > 0;
    const hasMarquee = this.state.marqueeRect !== null;
    const hasError = this.state.selectionError !== null;
    if (!hasSelection && !hasMarquee && (!clearError || !hasError)) return;
    this.setState({
      selectedPanelIds: [],
      selectedObstructionIds: [],
      marqueeRect: null,
      selectionDimsLabel: null,
      selectionError: clearError ? null : this.state.selectionError,
    });
  }

  showSelectionError = (message: string) => {
    if (this.errorTimer !== null) {
      window.clearTimeout(this.errorTimer);
    }
    this.setState({ selectionError: message });
    this.errorTimer = window.setTimeout(() => {
      this.setState({ selectionError: null });
      this.errorTimer = null;
    }, 4000);
  }

  attachSelectListeners = () => {
    window.addEventListener('mousedown', this.handleSelectMouseDown, true);
    window.addEventListener('mousemove', this.handleSelectMouseMove, true);
    window.addEventListener('mouseup', this.handleSelectMouseUp, true);
    window.addEventListener('contextmenu', this.handleSelectContextMenu, true);
    window.addEventListener('pointerdown', this.handleSelectPointerEvent, true);
    window.addEventListener('pointerup', this.handleSelectPointerEvent, true);
    window.addEventListener('click', this.handleSelectPointerEvent, true);
    window.addEventListener('dblclick', this.handleSelectPointerEvent, true);
    this.beginPanelSpriteRemovalSuppression();
    this.startHighlightTicker();
  }

  detachSelectListeners = () => {
    window.removeEventListener('mousedown', this.handleSelectMouseDown, true);
    window.removeEventListener('mousemove', this.handleSelectMouseMove, true);
    window.removeEventListener('mouseup', this.handleSelectMouseUp, true);
    window.removeEventListener('contextmenu', this.handleSelectContextMenu, true);
    window.removeEventListener('pointerdown', this.handleSelectPointerEvent, true);
    window.removeEventListener('pointerup', this.handleSelectPointerEvent, true);
    window.removeEventListener('click', this.handleSelectPointerEvent, true);
    window.removeEventListener('dblclick', this.handleSelectPointerEvent, true);
    this.endPanelSpriteRemovalSuppression();
    this.stopHighlightTicker();
  }

  handleSelectPointerEvent = (e: Event) => {
    if (this.state.activeTool !== 'select') return;
    const me = e as MouseEvent;
    if (typeof me.clientX !== 'number' || typeof me.clientY !== 'number') return;
    if (!this.isPointInOverlay(me.clientX, me.clientY)) return;
    if (this.isInteractiveTarget(e.target)) return;
    if (typeof me.button === 'number' && me.button > 0) return;
    e.stopPropagation();
    if (typeof (e as any).stopImmediatePropagation === 'function') {
      (e as any).stopImmediatePropagation();
    }
  }

  isPointInOverlay = (clientX: number, clientY: number): boolean => {
    const overlay = this.overlayRef;
    if (!overlay) return false;
    const r = overlay.getBoundingClientRect();
    return clientX >= r.left && clientX <= r.right && clientY >= r.top && clientY <= r.bottom;
  }

  isInteractiveTarget = (target: EventTarget | null): boolean => {
    if (!(target instanceof Element)) return false;
    if (target.closest('.v3-selection-bar') || target.closest('.v3-selection-error')) return true;
    if (target.closest('.v3-toolbar')) return true;
    if (target.closest('.v3-modal-overlay')) return true;
    return false;
  }

  handleSelectContextMenu = (e: MouseEvent) => {
    if (this.state.activeTool !== 'select') return;
    if (!this.isPointInOverlay(e.clientX, e.clientY)) return;
    if (this.state.moveMode) {
      e.preventDefault();
    }
  }

  handleSelectMouseDown = (e: MouseEvent) => {
    if (this.state.activeTool !== 'select') return;
    if (!this.isPointInOverlay(e.clientX, e.clientY)) return;
    if (this.isInteractiveTarget(e.target)) return;

    if (e.button === 1) {
      this.isMiddleSuspended = true;
      this.moveAnchor = null;
      return;
    }

    if (this.state.moveMode) {
      if (e.button === 0) {
        const point = this.getOverlayCoordsFromClient(e.clientX, e.clientY);
        this.commitMove(point);
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
      return;
    }

    if (e.button !== 0) return;
    const start = this.getOverlayCoordsFromClient(e.clientX, e.clientY);
    this.marqueeStart = start;
    this.isDragging = true;
    this.setState({
      marqueeRect: { x: start.x, y: start.y, w: 0, h: 0 },
      selectionDimsLabel: null,
      selectionError: null,
    });
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
  }

  handleSelectMouseMove = (e: MouseEvent) => {
    if (this.state.activeTool !== 'select') return;

    if (this.isDragging && this.marqueeStart) {
      const cur = this.getOverlayCoordsFromClient(e.clientX, e.clientY);
      const rx = Math.min(this.marqueeStart.x, cur.x);
      const ry = Math.min(this.marqueeStart.y, cur.y);
      const rw = Math.abs(cur.x - this.marqueeStart.x);
      const rh = Math.abs(cur.y - this.marqueeStart.y);
      const { metersPerPixel } = getSettings();
      const scale = getPanelsContainerScale();
      const widthLabel = formatInches(rw / scale.x, metersPerPixel);
      const heightLabel = formatInches(rh / scale.y, metersPerPixel);
      this.setState({
        marqueeRect: { x: rx, y: ry, w: rw, h: rh },
        selectionDimsLabel: `${widthLabel} \u00d7 ${heightLabel}`,
      });
      e.stopPropagation();
      return;
    }

    if (this.state.moveMode && !this.isMiddleSuspended) {
      if (!this.isPointInOverlay(e.clientX, e.clientY)) return;
      const point = this.getOverlayCoordsFromClient(e.clientX, e.clientY);
      this.handleMovePreview(point);
    }
  }

  handleSelectMouseUp = (e: MouseEvent) => {
    if (this.state.activeTool !== 'select') return;

    if (e.button === 1 && this.isMiddleSuspended) {
      this.isMiddleSuspended = false;
      if (this.state.moveMode) {
        this.moveAnchor = null;
      }
      return;
    }

    if (e.button === 0 && this.isPointInOverlay(e.clientX, e.clientY) && !this.isInteractiveTarget(e.target)) {
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
    }

    if (!this.isDragging || !this.marqueeStart) return;
    if (e.button !== 0) return;

    const end = this.getOverlayCoordsFromClient(e.clientX, e.clientY);
    const dx = Math.abs(end.x - this.marqueeStart.x);
    const dy = Math.abs(end.y - this.marqueeStart.y);
    this.isDragging = false;

    if (dx <= 6 && dy <= 6) {
      this.marqueeStart = null;
      this.setState({ marqueeRect: null, selectionDimsLabel: null });
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
      return;
    }

    const overlayRect: SelectionRect = {
      x: Math.min(this.marqueeStart.x, end.x),
      y: Math.min(this.marqueeStart.y, end.y),
      w: Math.abs(end.x - this.marqueeStart.x),
      h: Math.abs(end.y - this.marqueeStart.y),
    };

    const { canvasCenter } = getSettings();
    const spritePositions = getPanelSpriteScreenPositions();
    const canvasToOverlay = this.computeCanvasToOverlayMapping();

    const projectPanel = (item: SelectableItem): { x: number; y: number } => {
      const sprite = spritePositions ? spritePositions.get(item.id) : undefined;
      if (sprite) {
        return {
          x: sprite.x * canvasToOverlay.scaleX + canvasToOverlay.offsetX,
          y: sprite.y * canvasToOverlay.scaleY + canvasToOverlay.offsetY,
        };
      }
      return {
        x: canvasCenter.x + item.x,
        y: canvasCenter.y + item.y,
      };
    };

    const projectObstruction = (item: SelectableItem): { x: number; y: number } => {
      return {
        x: canvasCenter.x + item.x,
        y: canvasCenter.y + item.y,
      };
    };

    const panels = getPanels()
      .map(p => toAABB(p, 'panel'))
      .filter((p): p is SelectableItem => {
        if (p === null) return false;
        const screen = projectPanel(p);
        return rectContainsPoint(overlayRect, screen.x, screen.y);
      });
    const obstructions = getObstructions()
      .map(o => toAABB(o, 'obstruction'))
      .filter((o): o is SelectableItem => {
        if (o === null) return false;
        const screen = projectObstruction(o);
        return rectContainsPoint(overlayRect, screen.x, screen.y);
      });

    this.marqueeStart = null;
    this.setState({
      selectedPanelIds: panels.map(p => p.id),
      selectedObstructionIds: obstructions.map(o => o.id),
      marqueeRect: null,
      selectionDimsLabel: null,
    });
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
  }

  getOverlayCoordsFromClient = (clientX: number, clientY: number): { x: number; y: number } => {
    if (!this.overlayRef) return { x: 0, y: 0 };
    const r = this.overlayRef.getBoundingClientRect();
    return { x: clientX - r.left, y: clientY - r.top };
  }

  computeCanvasToOverlayMapping = (): { scaleX: number; scaleY: number; offsetX: number; offsetY: number } => {
    if (this.canvasToOverlayCache) return this.canvasToOverlayCache;
    const overlay = this.overlayRef;
    if (!overlay) return { scaleX: 1, scaleY: 1, offsetX: 0, offsetY: 0 };
    const overlayRect = overlay.getBoundingClientRect();
    const canvas = overlay.parentElement
      ? overlay.parentElement.querySelector('canvas')
      : null;
    if (!canvas) return { scaleX: 1, scaleY: 1, offsetX: 0, offsetY: 0 };
    const canvasRect = canvas.getBoundingClientRect();
    const internalW = (canvas as HTMLCanvasElement).width || canvasRect.width || 1;
    const internalH = (canvas as HTMLCanvasElement).height || canvasRect.height || 1;
    this.canvasToOverlayCache = {
      scaleX: canvasRect.width / internalW,
      scaleY: canvasRect.height / internalH,
      offsetX: canvasRect.left - overlayRect.left,
      offsetY: canvasRect.top - overlayRect.top,
    };
    return this.canvasToOverlayCache;
  }

  handleWindowResize = () => {
    this.canvasToOverlayCache = null;
  }

  startHighlightTicker = () => {
    if (this.tickerId !== null) return;
    const loop = () => {
      // While the select tool is active, force a re-render every frame to
      // keep the overlay highlights (divs) in sync with the Pixi canvas
      // (stage zoom/pan and array movement). Caching the overlay mapping
      // avoids expensive getBoundingClientRect reflows.
      if (this.state.activeTool === 'select' && (this.state.selectedPanelIds.length > 0 || this.state.moveMode)) {
        this.forceUpdate();
      }
      this.tickerId = requestAnimationFrame(loop);
    };
    this.tickerId = requestAnimationFrame(loop);
  }

  stopHighlightTicker = () => {
    if (this.tickerId !== null) {
      cancelAnimationFrame(this.tickerId);
      this.tickerId = null;
    }
  }

  getSelectedCount = (): number => {
    return this.state.selectedPanelIds.length + this.state.selectedObstructionIds.length;
  }

  handleDeleteSelected = () => {
    const { selectedPanelIds } = this.state;
    if (this.getSelectedCount() === 0) return;
    if (selectedPanelIds.length > 0) {
      reduxDispatch(REMOVE_PANELS(selectedPanelIds));
    }
    this.clearSelection(false);
  }

  handleFlipSelected = () => {
    const { selectedPanelIds } = this.state;
    if (selectedPanelIds.length === 0) return;

    const allPanels = getPanels();
    const selectedSet = new Set(selectedPanelIds);
    const flipped: any[] = [];
    const flippedAabbs: SelectableItem[] = [];

    for (const panel of allPanels) {
      if (!selectedSet.has(panel.id)) continue;
      const flippedPanel = {
        ...panel,
        width: panel.height,
        height: panel.width,
        landscape: !panel.landscape,
      };
      flipped.push(flippedPanel);
      const aabb = toAABB(flippedPanel, 'panel');
      if (aabb) flippedAabbs.push(aabb);
    }

    if (flipped.length === 0) return;

    const others: SelectableItem[] = [];
    for (const panel of allPanels) {
      if (selectedSet.has(panel.id)) continue;
      const aabb = toAABB(panel, 'panel');
      if (aabb) others.push(aabb);
    }
    for (const obs of getObstructions()) {
      const aabb = toAABB(obs, 'obstruction');
      if (aabb) others.push(aabb);
    }

    for (let i = 0; i < flippedAabbs.length; i += 1) {
      for (let j = i + 1; j < flippedAabbs.length; j += 1) {
        if (aabbIntersect(flippedAabbs[i], flippedAabbs[j])) {
          this.showSelectionError(FLIP_OVERLAP_ERROR);
          return;
        }
      }
      for (const other of others) {
        if (aabbIntersect(flippedAabbs[i], other)) {
          this.showSelectionError(FLIP_OVERLAP_ERROR);
          return;
        }
      }
    }

    reduxDispatch(UPDATE_PANELS(flipped));
  }

  handleToggleMove = () => {
    if (this.state.moveMode) {
      this.cancelMove();
      return;
    }
    if (this.state.selectedPanelIds.length === 0) return;
    const selectedSet = new Set(this.state.selectedPanelIds);
    const snapshot = getPanels()
      .filter((p: any) => selectedSet.has(p.id))
      .map((p: any) => ({ ...p }));
    if (snapshot.length === 0) return;
    this.moveOriginalPanels = snapshot;
    this.moveResumeBase = snapshot.map(p => ({ ...p }));
    this.moveAnchor = null;
    reduxDispatch(DISABLE_RUBBER_BAND());
    reduxDispatch(BLOCK_CREATING_PANEL());
    this.setState({ moveMode: true, selectionError: null });
    showMoveArrayGuidance();
  }

  cancelMove = () => {
    if (!this.state.moveMode && this.moveOriginalPanels.length === 0) return;
    if (this.moveOriginalPanels.length > 0) {
      reduxDispatch(UPDATE_PANELS(this.moveOriginalPanels.map(p => ({ ...p }))));
    }
    this.moveOriginalPanels = [];
    this.moveResumeBase = [];
    this.moveAnchor = null;
    dismissMoveArrayGuidance();
    if (this.state.moveMode) {
      this.setState({ moveMode: false });
    }
  }

  resyncMoveBaseToCurrent = () => {
    if (this.moveOriginalPanels.length === 0) return;
    const ids = new Set(this.moveOriginalPanels.map((p: any) => p.id));
    const current = getPanels()
      .filter((p: any) => ids.has(p.id))
      .map((p: any) => ({ ...p }));
    if (current.length > 0) {
      this.moveResumeBase = current;
    }
  }

  applyMoveDelta = (dxStage: number, dyStage: number): any[] => {
    const base = this.moveResumeBase.length > 0 ? this.moveResumeBase : this.moveOriginalPanels;
    return base.map(p => ({
      ...p,
      x: p.x + dxStage,
      y: p.y + dyStage,
    }));
  }

  computeStageDeltaFromOverlay = (overlayDx: number, overlayDy: number): { dx: number; dy: number } => {
    const scale = getPanelsContainerScale();
    return {
      dx: overlayDx / (scale.x || 1),
      dy: overlayDy / (scale.y || 1),
    };
  }

  isPointOverSelectedPanels = (overlayPoint: { x: number; y: number }): boolean => {
    const positions = getPanelSpriteScreenPositions(this.state.selectedPanelIds);
    if (!positions) return false;
    const m = this.computeCanvasToOverlayMapping();
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    positions.forEach((p) => {
      const w = (p.w || 0) * m.scaleX;
      const h = (p.h || 0) * m.scaleY;
      const cx = p.x * m.scaleX + m.offsetX;
      const cy = p.y * m.scaleY + m.offsetY;
      minX = Math.min(minX, cx - w / 2);
      minY = Math.min(minY, cy - h / 2);
      maxX = Math.max(maxX, cx + w / 2);
      maxY = Math.max(maxY, cy + h / 2);
    });
    if (minX === Infinity) return false;
    return overlayPoint.x >= minX && overlayPoint.x <= maxX
      && overlayPoint.y >= minY && overlayPoint.y <= maxY;
  }

  handleMovePreview = (overlayPoint: { x: number; y: number }) => {
    if (!this.state.moveMode || this.moveOriginalPanels.length === 0) return;
    if (!this.moveAnchor) {
      if (!this.isPointOverSelectedPanels(overlayPoint)) return;
      this.moveAnchor = overlayPoint;
      this.resyncMoveBaseToCurrent();
      dismissMoveArrayGuidance();
    }
    const { dx, dy } = this.computeStageDeltaFromOverlay(
      overlayPoint.x - this.moveAnchor.x,
      overlayPoint.y - this.moveAnchor.y,
    );
    const moved = this.applyMoveDelta(dx, dy);
    reduxDispatch(UPDATE_PANELS(moved));
  }

  applyEmitFilterToSuppressedSprites = () => {
    if (!this.selectToolSuppressionActive) return;
    const container: any = getPanelsContainer ? getPanelsContainer() : null;
    if (!container || !Array.isArray(container.children)) return;
    const alreadyPatched = new Set(this.suppressedSprites.map(entry => entry.sprite));
    const blockedEvents = new Set([
      'pointerup', 'mouseup', 'pointerdown', 'mousedown',
      'pointertap', 'click', 'tap', 'rightclick', 'rightup', 'rightdown',
    ]);
    for (const sprite of container.children) {
      if (!sprite || alreadyPatched.has(sprite)) continue;
      if (typeof sprite.emit !== 'function') continue;
      const originalEmit = sprite.emit.bind(sprite);
      this.suppressedSprites.push({ sprite, originalEmit });
      sprite.emit = function patchedEmit(eventName: string, ...args: any[]) {
        if (blockedEvents.has(eventName)) {
          return false;
        }
        return originalEmit(eventName, ...args);
      };
    }
  }

  beginPanelSpriteRemovalSuppression = () => {
    if (this.selectToolSuppressionActive) return;
    this.selectToolSuppressionActive = true;
    this.suppressedSprites = [];
    this.applyEmitFilterToSuppressedSprites();
    if (this.selectToolStoreUnsubscribe) return;
    this.selectToolStoreUnsubscribe = reduxStore.subscribe(() => {
      this.applyEmitFilterToSuppressedSprites();
    });
  }

  endPanelSpriteRemovalSuppression = () => {
    if (this.selectToolStoreUnsubscribe) {
      this.selectToolStoreUnsubscribe();
      this.selectToolStoreUnsubscribe = null;
    }
    for (const entry of this.suppressedSprites) {
      if (entry.sprite && typeof entry.originalEmit === 'function') {
        entry.sprite.emit = entry.originalEmit;
      }
    }
    this.suppressedSprites = [];
    this.selectToolSuppressionActive = false;
  }

  refreshArrayNumbers = () => {
    const currentPanels = getPanels();
    if (currentPanels.length === 0) {
      return;
    }
    const regrouped = this.recomputePanelGroupIds([]);
    const updatesById = new Map<number, any>(regrouped.nonMovedUpdates.map((p: any) => [p.id, p]));
    const allPanelUpdates = currentPanels.map((p: any) => {
      const updated = updatesById.get(p.id);
      return updated ? updated : { ...p };
    });
    reduxDispatch(UPDATE_PANELS(allPanelUpdates));
    if (this.props.showArrayNumber) {
      reduxDispatch(DISABLE_ARRAY_NUMBER_FEATURE());
      reduxDispatch(ENABLE_ARRAY_NUMBER_FEATURE());
    }
  }

  recomputePanelGroupIds = (movedPanels: any[]): { moved: any[]; nonMovedUpdates: any[] } => {
    const allPanels = getPanels();
    const movedById = new Map<number, any>(movedPanels.map((p: any) => [p.id, p]));
    const merged: any[] = allPanels.map((p: any) => movedById.has(p.id) ? movedById.get(p.id) : p);

    const s = state() as any;
    const rowSpacingMeters = (s && s.settings && typeof s.settings.rowSpacing === 'number') ? s.settings.rowSpacing : 0;
    const columnSpacingMeters = (s && s.settings && typeof s.settings.columnSpacing === 'number') ? s.settings.columnSpacing : 0;
    const metersPerPixel = (s && s.background && typeof s.background.metersPerPixel === 'number') ? s.background.metersPerPixel : 0;
    const rowSpacingPx = metersPerPixel ? rowSpacingMeters / metersPerPixel : 0;
    const columnSpacingPx = metersPerPixel ? columnSpacingMeters / metersPerPixel : 0;
    const tolerance = 0.5;

    const bounds = merged.map((p: any) => {
      const halfW = (p.width || 0) / 2;
      const halfH = (p.height || 0) / 2;
      return {
        left: p.x - halfW,
        right: p.x + halfW,
        top: p.y - halfH,
        bottom: p.y + halfH,
      };
    });

    const adjacent = (i: number, j: number): boolean => {
      const a = bounds[i];
      const b = bounds[j];
      const horizontalOverlap = !(a.right <= b.left || a.left >= b.right);
      const verticalOverlap = !(a.bottom <= b.top || a.top >= b.bottom);
      if (horizontalOverlap) {
        const gap = Math.min(Math.abs(a.bottom - b.top), Math.abs(b.bottom - a.top));
        if (gap <= rowSpacingPx + tolerance) return true;
      }
      if (verticalOverlap) {
        const gap = Math.min(Math.abs(a.right - b.left), Math.abs(b.right - a.left));
        if (gap <= columnSpacingPx + tolerance) return true;
      }
      return false;
    };

    const parent: number[] = merged.map((_, i) => i);
    const find = (i: number): number => {
      while (parent[i] !== i) {
        parent[i] = parent[parent[i]];
        i = parent[i];
      }
      return i;
    };
    const union = (i: number, j: number) => {
      const ri = find(i);
      const rj = find(j);
      if (ri !== rj) parent[ri] = rj;
    };

    for (let i = 0; i < merged.length; i += 1) {
      for (let j = i + 1; j < merged.length; j += 1) {
        if (adjacent(i, j)) union(i, j);
      }
    }

    const componentMembers = new Map<number, number[]>();
    for (let i = 0; i < merged.length; i += 1) {
      const root = find(i);
      const list = componentMembers.get(root);
      if (list) list.push(i);
      else componentMembers.set(root, [i]);
    }

    const newGroupIdByIndex = new Array<number>(merged.length);
    const usedGroupIds = new Set<number>();
    componentMembers.forEach((indices) => {
      const distinct = new Set<number>();
      for (const idx of indices) {
        const gid = merged[idx].groupId;
        if (typeof gid === 'number') distinct.add(gid);
      }
      let resolvedId: number;
      if (distinct.size === 1) {
        const onlyId = distinct.values().next().value as number;
        resolvedId = usedGroupIds.has(onlyId) ? nextUid() : onlyId;
      } else {
        resolvedId = nextUid();
      }
      usedGroupIds.add(resolvedId);
      for (const idx of indices) newGroupIdByIndex[idx] = resolvedId;
    });

    const updatedMoved: any[] = [];
    const nonMovedUpdates: any[] = [];
    for (let i = 0; i < merged.length; i += 1) {
      const panel = merged[i];
      const newGid = newGroupIdByIndex[i];
      if (panel.groupId === newGid) {
        if (movedById.has(panel.id)) updatedMoved.push(panel);
        continue;
      }
      const updated = { ...panel, groupId: newGid };
      if (movedById.has(panel.id)) updatedMoved.push(updated);
      else nonMovedUpdates.push(updated);
    }
    for (const m of movedPanels) {
      if (!updatedMoved.some((u: any) => u.id === m.id)) updatedMoved.push(m);
    }
    return { moved: updatedMoved, nonMovedUpdates };
  }

  commitMove = (overlayPoint: { x: number; y: number }) => {
    if (!this.state.moveMode || this.moveOriginalPanels.length === 0) return;
    const anchor = this.moveAnchor || overlayPoint;
    const { dx, dy } = this.computeStageDeltaFromOverlay(
      overlayPoint.x - anchor.x,
      overlayPoint.y - anchor.y,
    );
    const moved = this.applyMoveDelta(dx, dy);

    const movedAabbs: SelectableItem[] = [];
    for (const p of moved) {
      const aabb = toAABB(p, 'panel');
      if (aabb) movedAabbs.push(aabb);
    }

    const movedIds = new Set(moved.map((p: any) => p.id));
    const others: SelectableItem[] = [];
    for (const panel of getPanels()) {
      if (movedIds.has(panel.id)) continue;
      const aabb = toAABB(panel, 'panel');
      if (aabb) others.push(aabb);
    }
    for (const obs of getObstructions()) {
      const aabb = toAABB(obs, 'obstruction');
      if (aabb) others.push(aabb);
    }

    for (let i = 0; i < movedAabbs.length; i += 1) {
      for (let j = i + 1; j < movedAabbs.length; j += 1) {
        if (aabbIntersect(movedAabbs[i], movedAabbs[j])) {
          this.showSelectionError(MOVE_OVERLAP_ERROR);
          reduxDispatch(UPDATE_PANELS(this.moveOriginalPanels.map(p => ({ ...p }))));
          return;
        }
      }
      for (const other of others) {
        if (aabbIntersect(movedAabbs[i], other)) {
          this.showSelectionError(MOVE_OVERLAP_ERROR);
          reduxDispatch(UPDATE_PANELS(this.moveOriginalPanels.map(p => ({ ...p }))));
          return;
        }
      }
    }

    const regrouped = this.recomputePanelGroupIds(moved);

    reduxDispatch(BLOCK_CREATING_PANEL());
    reduxDispatch(DISABLE_RUBBER_BAND());
    if (regrouped.nonMovedUpdates.length > 0) {
      reduxDispatch(UPDATE_PANELS(regrouped.nonMovedUpdates));
    }
    reduxDispatch(UPDATE_PANELS(regrouped.moved));
    this.moveOriginalPanels = [];
    this.moveResumeBase = [];
    this.moveAnchor = null;
    dismissMoveArrayGuidance();
    this.setState({ moveMode: false });
  }

  // ── Render helpers ─────────────────────────────────────────────────

  renderToolBtn(
    id: string,
    icon: React.ReactNode,
    label: string,
    opts?: { disabled?: boolean; danger?: boolean; tooltip?: string; initialTooltip?: string; showInitialTooltip?: boolean },
  ) {
    const { activeTool } = this.state;
    const isActive = activeTool === id;
    const isDisabled = opts && opts.disabled;
    const cls = `v3-tool-btn ${isActive ? 'active' : ''} ${isDisabled ? 'disabled' : ''} ${opts && opts.danger ? 'danger' : ''}`;
    const tooltip = opts && opts.showInitialTooltip && opts.initialTooltip ? opts.initialTooltip : opts && opts.tooltip;
    return (
      <V3ToolHoverTooltip id={id} label={tooltip} open={opts && opts.showInitialTooltip}>
        <button
          type="button"
          className={cls}
          onClick={() => !isDisabled && this.handleToolSelect(id)}
          onMouseEnter={() => opts && opts.showInitialTooltip && this.dismissInitialTooltip(id)}
          aria-describedby={tooltip ? `v3-${id}-hover-tooltip` : undefined}
        >
          {icon}<span>{label}</span>
        </button>
      </V3ToolHoverTooltip>
    );
  }

  dismissInitialTooltip = (id: string) => {
    if (id === 'addpanel' && !this.state.addPanelInitialTooltipDismissed) {
      this.setState({ addPanelInitialTooltipDismissed: true });
    }
    if (id === 'markroof' && !this.state.markRoofInitialTooltipDismissed) {
      this.setState({ markRoofInitialTooltipDismissed: true });
    }
  }

  renderSelectionOverlay() {
    const { activeTool, marqueeRect } = this.state;
    if (activeTool !== 'select') return null;
    const { selectionDimsLabel } = this.state;
    return (
      <div
        ref={this.setOverlayRef}
        className="v3-select-overlay"
      >
        {this.renderSelectionHighlights()}
        {marqueeRect && (
          <div
            className="v3-select-marquee"
            style={{
              left: marqueeRect.x,
              top: marqueeRect.y,
              width: marqueeRect.w,
              height: marqueeRect.h,
            }}
          >
            {selectionDimsLabel && (
              <span className="v3-select-marquee-dims">{selectionDimsLabel}</span>
            )}
          </div>
        )}
      </div>
    );
  }

  renderSelectionHighlights() {
    const { selectedPanelIds } = this.state;
    if (selectedPanelIds.length === 0) return null;
    const positions = getPanelSpriteScreenPositions(selectedPanelIds);
    if (!positions) return null;
    const m = this.computeCanvasToOverlayMapping();
    return selectedPanelIds.map(id => {
      const p = positions.get(id);
      if (!p) return null;
      const w = (p.w || 0) * m.scaleX;
      const h = (p.h || 0) * m.scaleY;
      return (
        <div
          key={id}
          className="v3-select-highlight"
          style={{
            left: p.x * m.scaleX + m.offsetX - w / 2,
            top: p.y * m.scaleY + m.offsetY - h / 2,
            width: w,
            height: h,
          }}
        />
      );
    });
  }

  renderSelectionBar() {
    const { activeTool, selectionError } = this.state;
    const count = this.getSelectedCount();
    if (activeTool !== 'select') return null;
    if (count === 0 && !selectionError) return null;

    return (
      <React.Fragment>
        {count > 0 && (
          <div className="v3-selection-bar-wrap">
            <div className="v3-selection-bar">
              <span className="v3-sel-bar-count">{count === 1 ? '1 selected' : `${count} selected`}</span>
              <div className="v3-sel-bar-sep" />
              <button
                type="button"
                className={`v3-sel-bar-btn ${this.state.moveMode ? 'active' : ''}`}
                onClick={this.handleToggleMove}
                disabled={this.state.selectedPanelIds.length === 0}
                title={this.state.selectedPanelIds.length === 0 ? 'No panels in selection' : undefined}
              >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M6 1.5v9M1.5 6h9M6 1.5L4 3.5M6 1.5L8 3.5M6 10.5L4 8.5M6 10.5L8 8.5M1.5 6L3.5 4M1.5 6L3.5 8M10.5 6L8.5 4M10.5 6L8.5 8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                {this.state.moveMode ? 'Cancel Move' : 'Move Selection'}
              </button>
              {/* <button
                type="button"
                className="v3-sel-bar-btn"
                onClick={this.handleFlipSelected}
                disabled={this.state.selectedPanelIds.length === 0 || this.state.moveMode}
                title={this.state.selectedPanelIds.length === 0 ? 'No panels in selection' : undefined}
              >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M1 6h10M8 3l3 3-3 3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Flip Orientation
              </button> */}
              <button
                type="button"
                className="v3-sel-bar-btn danger"
                onClick={this.handleDeleteSelected}
                disabled={this.state.moveMode}
              >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 3h8M5 3V2h2v1M10 3l-.7 7H2.7L2 3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Delete
              </button>
              <button
                type="button"
                className="v3-sel-bar-close"
                onClick={() => this.clearSelection(true)}
                aria-label="Clear selection"
              >
                &#x2715;
              </button>
            </div>
          </div>
        )}
        {selectionError && (
          <div className="v3-selection-error-wrap">
            <div className="v3-info-banner v3-info-warn v3-selection-error">
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M6.5 1L12 11H1L6.5 1z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" fill="none" />
                <path d="M6.5 5v3M6.5 9.5h.01" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
              </svg>
              <span>{selectionError}</span>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }

  render() {
    const { productId, projectName, user, dispatch, editorReady, selectedRoofId, backgroundCords, showArrayNumber, domesticContent } = this.props;
    const {
      orientation,
      viewMode,
      navigateMode,
      zoom,
      unitMode,
      pendingViewSwitch,
      switchingView,
      leftPanelCollapsed,
      rightPanelCollapsed,
      addPanelInitialTooltipDismissed,
      markRoofInitialTooltipDismissed,
    } = this.state;
    const workspaceBodyClass = [
      'v3-workspace-body',
      leftPanelCollapsed && rightPanelCollapsed ? 'both-collapsed'
        : leftPanelCollapsed ? 'left-collapsed'
          : rightPanelCollapsed ? 'right-collapsed'
            : '',
    ].filter(Boolean).join(' ');
    const isSatellite = viewMode === 'satellite';
    const hasEditorCoordinates = isValidCoordinates(backgroundCords);
    // In satellite, panel/obstruction tools are disabled until the user has
    // marked a roof AND the legacy panels editor has activated it (which sets
    // both background.selectedRoofId and background.cords). In canvas, the
    // seeded roof is normally active; the readiness check below still keeps a
    // malformed or transitional state away from PanelsEditor.
    const noActiveRoof = isSatellite && (!selectedRoofId || !hasEditorCoordinates);
    // RM-family (flat-roof) products in UB Lite only support landscape
    // orientation; hide the Portrait pill so the user can't switch.
    const numericProductIdForOrient = this.getNumericProductId();
    const portraitDisabled = isRMFamily(numericProductIdForOrient);
    // Satellite has two sub-modes:
    //   - roof-marking view (no selectedRoofId) → show Google Maps satellite
    //   - per-roof editor view (selectedRoofId set) → show PanelsEditor on that roof
    const inRoofEditor = isSatellite && !!selectedRoofId;
    const numPid = this.getNumericProductId();
    const isCommercial = numPid ? isCommercialProduct(numPid) : false;
    const obsDisabled = !isCommercial || noActiveRoof;
    // Keep the editor shell visible while coordinates are being activated, but
    // do not mount PanelsEditor until its required roof center is available.
    const showPanelsEditor = !switchingView && (!isSatellite || inRoofEditor);
    const canMountPanelsEditor = Boolean(editorReady && hasEditorCoordinates);
    const showSatelliteMap = isSatellite && !inRoofEditor;
    const hasPanels = (this.props.panels || []).length > 0;
    const showInitialAddPanelTooltip = !noActiveRoof && !hasPanels && !addPanelInitialTooltipDismissed;
    const showInitialMarkRoofTooltip = showSatelliteMap && !hasUserMarkedRoof() && this.state.activeTool !== 'markroof' && !markRoofInitialTooltipDismissed;

    return (
      <div className="v3-screen v3-design-workspace">
        {/* ── NAV BAR ── */}
        <V3Nav
          variant="workspace"
          onLogoClick={() => AppHistory.push('/lite/dashboard')}
          logo={
            <span className="v3-nav-logo-text">
              <img src={require('assets/media/logos/U-Builder_Go_Logo.png')} style={{ height: 24 }} />
            </span>
          }
          leftSlot={
            <V3Breadcrumb
              crumbs={[
                { label: 'Projects', onClick: () => AppHistory.push('/lite/dashboard') },
                { label: projectName || 'Untitled Project' },
              ]}
              editable={true}
            />
          }
          rightSlot={
            <React.Fragment>
              <V3AutosaveIndicator />
              <button
                type="button"
                className="v3-save-profile-btn"
                onClick={this.openSaveProfile}
                disabled={!this.getNumericProductId()}
              >
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path d="M2 2h7l2 2v7H2z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
                  <path d="M4 2v3h5V2M4 7h5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
                </svg>
                Save as Profile
              </button>
              {user && dispatch && <V3AvatarMenu user={user} dispatch={dispatch} />}
            </React.Fragment>
          }
        />

        {/* ── WORKSPACE BODY (3-column grid) ── */}
        <div className={workspaceBodyClass}>
          {/* LEFT PANEL */}
          <V3LeftPanel>
            <ModuleSection
              unitMode={unitMode}
              onUnitChange={this.handleUnitChange}
              onPanelsCleared={this.handlePanelsCleared}
            />
            <LocationSection />
            <AdvancedSection
              forceOpenSignal={this.state.advancedForceOpenSignal}
              domesticClampTarget={this.state.domesticClampTarget}
              onDomesticClampResolved={this.onDomesticClampResolved}
              onSwitchDomesticOff={this.onSwitchDomesticOff}
              projectId={this.props.projectId}
              liteUpdating={this.props.liteUpdating}
            />
          </V3LeftPanel>

          {/* CENTER PANEL */}
          <div className="v3-center-panel">
            <button
              type="button"
              className="v3-seam-toggle v3-seam-toggle--left"
              onClick={this.handleToggleLeftPanel}
              aria-label={leftPanelCollapsed ? 'Expand left panel' : 'Collapse left panel'}
              aria-expanded={!leftPanelCollapsed}
            >
              {leftPanelCollapsed ? (
                <svg viewBox="0 0 12 12" fill="none"><path d="M5 2 L9 6 L5 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
              ) : (
                <svg viewBox="0 0 12 12" fill="none"><path d="M7 2 L3 6 L7 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
              )}
            </button>
            <button
              type="button"
              className="v3-seam-toggle v3-seam-toggle--right"
              onClick={this.handleToggleRightPanel}
              aria-label={rightPanelCollapsed ? 'Expand right panel' : 'Collapse right panel'}
              aria-expanded={!rightPanelCollapsed}
            >
              {rightPanelCollapsed ? (
                <svg viewBox="0 0 12 12" fill="none"><path d="M7 2 L3 6 L7 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
              ) : (
                <svg viewBox="0 0 12 12" fill="none"><path d="M5 2 L9 6 L5 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
              )}
            </button>
            {/* ── HENI TOOLBAR (2 rows) ── */}
            <div className="v3-toolbar">
              {/* ROW 1: Drawing tools.
                  Layout intent: tools that are functional in design mode are
                  grouped together on the left; tools that stay disabled in
                  design mode (obstructions, satellite-only) are grouped on
                  the right. Each tool's disable logic / tooltip / handler is
                  unchanged from before — this is purely a reorder so the
                  active set reads as one block instead of being interleaved
                  with always-disabled controls.
                  In satellite view Mark Roof is the primary action (until
                  a roof is opened in the editor), so it gets promoted to
                  the first slot. The same button is rendered in its
                  inactive-group spot when NOT in satellite — only the
                  location toggles, the disable/tooltip/handler are
                  identical in both spots. */}
              {isSatellite && (
                <div className="v3-tool-group">
                  {this.renderToolBtn('markroof',
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M6.5 1.5L1.5 6v5h10V6L6.5 1.5z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" /></svg>,
                    'Mark Roof',
                    !isSatellite
                      ? { disabled: true, tooltip: 'Only applicable in satellite view' }
                      : inRoofEditor
                        ? { disabled: true, tooltip: 'Exit roof editor to mark another roof' }
                        : {
                          tooltip: MARK_ROOF_TOOLTIP,
                          initialTooltip: MARK_ROOF_INITIAL_TOOLTIP,
                          showInitialTooltip: showInitialMarkRoofTooltip,
                        })}
                </div>
              )}
              <div className="v3-tool-group">
                {this.renderToolBtn('addpanel',
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M6.5 1.5v10M1.5 6.5h10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>,
                  'Add Panel',
                  noActiveRoof
                    ? { disabled: true, tooltip: 'Draw and select a roof first' }
                    : {
                      tooltip: ADD_PANEL_TOOLTIP,
                      initialTooltip: ADD_PANEL_INITIAL_TOOLTIP,
                      showInitialTooltip: showInitialAddPanelTooltip,
                    })}
                {this.renderToolBtn('removepanel',
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M1.5 6.5h10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>,
                  'Remove Panel',
                  noActiveRoof ? { disabled: true, tooltip: 'Draw and select a roof first' } : undefined)}
              </div>
              <div className="v3-tool-group">
                {this.renderToolBtn('select',
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2.5 2.5l3.5 8 1.5-3 3-1.5-8-3.5z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" /></svg>,
                  'Select',
                  noActiveRoof ? { disabled: true, tooltip: 'Draw and select a roof first' } : undefined)}
                {this.renderToolBtn('measure',
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 11L11 2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" /><path d="M2 8v3h3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" /><path d="M8 2h3v3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" /></svg>,
                  'Measure',
                  (isSatellite && !inRoofEditor) ? { disabled: true, tooltip: 'Only available inside a roof area' } : undefined)}
              </div>
              <div className="v3-tool-group">
                {this.renderToolBtn('addobs',
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="2" y="2" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.3" /><path d="M6.5 4.5v4M4.5 6.5h4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" /></svg>,
                  'Add Obstruction',
                  obsDisabled ? { disabled: true, tooltip: !isCommercial ? 'Only available for commercial products' : 'Draw and select a roof first' } : undefined)}
                {this.renderToolBtn('removeobs',
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="2" y="2" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.3" /><path d="M4 4l5 5M9 4L4 9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" /></svg>,
                  'Remove Obstruction',
                  obsDisabled ? { disabled: true, tooltip: !isCommercial ? 'Only available for commercial products' : 'Draw and select a roof first' } : undefined)}
              </div>
              <div className="v3-tool-group">
                {!isSatellite && this.renderToolBtn('markroof',
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M6.5 1.5L1.5 6v5h10V6L6.5 1.5z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" /></svg>,
                  'Mark Roof',
                  !isSatellite
                    ? { disabled: true, tooltip: 'Only applicable in satellite view' }
                    : inRoofEditor
                      ? { disabled: true, tooltip: 'Exit roof editor to mark another roof' }
                      : { tooltip: MARK_ROOF_TOOLTIP })}
                {this.renderToolBtn('fillarea',
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1" y="1" width="4.5" height="4.5" rx="1" fill="currentColor" opacity=".65" /><rect x="7.5" y="1" width="4.5" height="4.5" rx="1" fill="currentColor" opacity=".65" /><rect x="1" y="7.5" width="4.5" height="4.5" rx="1" fill="currentColor" opacity=".65" /><rect x="7.5" y="7.5" width="4.5" height="4.5" rx="1" fill="currentColor" opacity=".65" /></svg>,
                  'Fill Area',
                  inRoofEditor
                    ? undefined
                    : isSatellite
                      ? { disabled: true, tooltip: 'Draw a roof first' }
                      : { disabled: true, tooltip: 'Only applicable in satellite view' })}
              </div>

              {/* Line break between rows */}
              <div className="v3-toolbar-break" />

              {/* ROW 2: Orientation | Undo/Redo/Clear | spacer | View toggle */}
              {/* Orientation pill is usable in canvas mode AND in the
                  per-roof satellite editor sub-view (where panels are being
                  placed on a marked roof). Disabled only in the satellite
                  roof-marking sub-view, where there's no editor to apply it to. */}
              <div className={`v3-tool-group ${(isSatellite && !inRoofEditor) ? 'disabled' : ''}`}>
                <div className="v3-orient-pill">
                  {!portraitDisabled && (
                    <button type="button" className={`v3-orient-btn ${orientation === 'portrait' ? 'active' : ''} ${(isSatellite && isCommercial) ? 'disabled' : (isSatellite && !inRoofEditor) ? 'disabled' : ''}`}
                      onClick={() => !(isSatellite && isCommercial) && !(isSatellite && !inRoofEditor) && this.handleOrientationChange('portrait')}>
                      <svg width="11" height="13" viewBox="0 0 11 13" fill="none"><rect x="1" y="1" width="9" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.3" /></svg>
                      Portrait
                    </button>
                  )}
                  <button type="button" className={`v3-orient-btn ${orientation === 'landscape' ? 'active' : ''} ${(isSatellite && !inRoofEditor) ? 'disabled' : ''}`}
                    onClick={() => !(isSatellite && !inRoofEditor) && this.handleOrientationChange('landscape')}>
                    <svg width="13" height="11" viewBox="0 0 13 11" fill="none"><rect x="1" y="1" width="11" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.3" /></svg>
                    Landscape
                  </button>
                </div>
              </div>
              <div className={`v3-tool-group ${(isSatellite && !inRoofEditor) ? 'disabled' : ''}`}>
                <button type="button" className={`v3-tool-btn ${(isSatellite && !inRoofEditor) ? 'disabled' : ''}`}
                  onClick={() => !(isSatellite && !inRoofEditor) && this.handleUndo()}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 .49-3.48" /></svg>
                  <span>Undo</span>
                </button>
                <button type="button" className={`v3-tool-btn ${(isSatellite && !inRoofEditor) ? 'disabled' : ''}`}
                  onClick={() => !(isSatellite && !inRoofEditor) && this.handleRedo()}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-.49-3.48" /></svg>
                  <span>Redo</span>
                </button>
                <button type="button" className={`v3-tool-btn danger ${(isSatellite && !inRoofEditor) ? 'disabled' : ''}`}
                  onClick={() => !(isSatellite && !inRoofEditor) && this.handleClearAll()}>
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M4.5 2h4M2 3.5h9M3 3.5l.7 7h6.6l.7-7" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" /></svg>
                  <span>Clear All</span>
                </button>
              </div>
              <div className="v3-toolbar-spacer" />
              <div className="v3-tool-group">
                <div className="v3-view-pill">
                  <button type="button" className={`v3-view-btn ${!isSatellite ? 'active' : ''}`}
                    onClick={() => isSatellite && this.handleViewModeToggle()}>
                    Design
                  </button>
                  <button type="button" className={`v3-view-btn ${isSatellite ? 'active' : ''}`}
                    onClick={() => !isSatellite && this.handleViewModeToggle()}>
                    Satellite
                  </button>
                </div>
              </div>
              {inRoofEditor && (
                <div className="v3-tool-group">
                  <button type="button" className="v3-tool-btn" onClick={this.handleBackToRoofs}>
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M8 2L3 6.5 8 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    <span>Back to Roofs</span>
                  </button>
                </div>
              )}
              <div className="v3-tool-group">
                <button type="button" className={`v3-tool-btn ${navigateMode ? 'active' : ''}`} onClick={this.handleNavigateToggle}>
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M6.5 1C3.5 1 1 3.5 1 6.5S3.5 12 6.5 12 12 9.5 12 6.5 9.5 1 6.5 1z" stroke="currentColor" strokeWidth="1.2" /><path d="M6.5 4v5M4 6.5h5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" /></svg>
                  <span>Navigate Map</span>
                </button>
              </div>
              {isSatellite && !inRoofEditor && (
                <div className="v3-tool-group">
                  <button type="button" className="v3-tool-btn" onClick={() => googleMapRelocation()}>
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M6.5 1.5v10M1.5 6.5h10" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" /><circle cx="6.5" cy="6.5" r="3" stroke="currentColor" strokeWidth="1.2" fill="none" /></svg>
                    <span>Go to Roofs</span>
                  </button>
                </div>
              )}
              {isSatellite && (
                <div className="v3-tool-group">
                  <div className="v3-zoom-controls">
                    <button type="button" className="v3-zoom-btn" onClick={this.handleZoomOut}>&minus;</button>
                    <span className="v3-zoom-level">Zoom</span>
                    <button type="button" className="v3-zoom-btn" onClick={this.handleZoomIn}>+</button>
                  </div>
                </div>
              )}
            </div>

            {/* ── CANVAS AREA ── */}
            {/* `selectedRoofId` chooses the satellite sub-view, while
                `backgroundCords` is the actual PanelsEditor readiness signal.
                This keeps the editor unmounted during activation/deactivation
                transitions instead of letting map calculations read null. */}
            {showPanelsEditor && (
              canMountPanelsEditor ? (
                <div
                  className={[
                    'v3-editor-stack',
                    !isSatellite ? 'v3-canvas-container view-canvas' : '',
                  ].filter(Boolean).join(' ')}
                  key={`editor-${this.state.editorKey}`}
                >
                  <PanelsEditor productId={productId} />
                  {this.renderSelectionOverlay()}
                  {this.renderSelectionBar()}
                </div>
              ) : (
                <div className="v3-canvas-container view-canvas">
                  <div className="v3-canvas-empty">
                    <div className="v3-canvas-empty-icon">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M14 3L3 11v14h8v-7h6v7h8V11L14 3z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div className="v3-canvas-empty-steps">
                      <span>Loading panel editor...</span>
                    </div>
                  </div>
                </div>
              )
            )}
            {showSatelliteMap && (
              <div className="v3-canvas-container view-satellite">
                <div className={`v3-map-mode-badge ${navigateMode ? 'navigate' : 'design'}`}>
                  {navigateMode ? 'NAVIGATE MODE' : 'DESIGN MODE'}
                </div>

                {/* Google Maps satellite view */}
                <div
                  ref={this.mapContainerRef}
                  className="v3-satellite-map"
                  style={{ width: '100%', height: '100%' }}
                />

                {/* Location search overlay (Places Autocomplete) — sits on top
                    of the map, top-left, matching the Lite tool-pill style. */}
                <div className="v3-map-search">
                  <svg className="v3-map-search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.35-4.35" /></svg>
                  <input
                    ref={this.searchInputRef}
                    type="text"
                    placeholder="Search address or location"
                  />
                </div>

                {/* Compass */}
                <div className="v3-canvas-compass">
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <circle cx="18" cy="18" r="16" stroke="currentColor" strokeWidth="1.5" opacity=".3" />
                    <polygon points="18,6 21,18 18,15 15,18" fill="currentColor" />
                    <polygon points="18,30 21,18 18,21 15,18" fill="currentColor" opacity=".3" />
                    <text x="18" y="5" textAnchor="middle" fontSize="6" fontFamily="PT Sans" fontWeight="700" fill="currentColor">N</text>
                  </svg>
                </div>

                {/* Legend */}
                <div className="v3-canvas-legend">
                  <div className="v3-legend-row">
                    <div className="v3-legend-swatch v3-legend-panel" />
                    <span>Solar Panel</span>
                  </div>
                  <div className="v3-legend-row">
                    <div className="v3-legend-swatch v3-legend-obstruction" />
                    <span>Obstruction</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* RIGHT PANEL */}
          <BomPanel
            domesticContent={!!domesticContent}
            onDomesticToggle={this.handleDomesticToggle}
            projectId={this.props.projectId}
          />
        </div>

        {this.state.clearAllConfirmOpen && (
          <div className="v3-modal-overlay" onClick={this.cancelClearAll}>
            <div className="v3-modal-card" style={{ width: 420 }} onClick={(e) => e.stopPropagation()}>
              <div className="v3-modal-top">
                <div className="v3-modal-step-label">WARNING</div>
                <div className="v3-modal-title">Clear all panels?</div>
              </div>
              <div className="v3-modal-body">
                <div className="v3-modal-subtitle">
                  This will remove all panels across all roof areas. This cannot be undone.
                </div>
              </div>
              <div className="v3-modal-footer">
                <V3Button variant="ghost" size="md" onClick={this.cancelClearAll}>Cancel</V3Button>
                <V3Button variant="primary" size="md" onClick={this.confirmClearAll}>Continue</V3Button>
              </div>
            </div>
          </div>
        )}

        {pendingViewSwitch && (
          <div className="v3-modal-overlay" onClick={this.cancelViewSwitch}>
            <div className="v3-modal-card" style={{ width: 460 }} onClick={(e) => e.stopPropagation()}>
              <div className="v3-modal-top">
                <div>
                  <div className="v3-modal-step-label">View Switch</div>
                  <div className="v3-modal-title">
                    Switch to {isSatellite ? 'Design' : 'Satellite'} view?
                  </div>
                </div>
              </div>
              <div className="v3-modal-body">
                <div className="v3-modal-subtitle">
                  {isSatellite
                    ? 'Switching to Design view will clear your current roof markings and panels. Continue?'
                    : 'Switching to Satellite view will clear your current panels. Continue?'}
                </div>
              </div>
              <div className="v3-modal-footer">
                <V3Button variant="ghost" size="md" onClick={this.cancelViewSwitch}>Cancel</V3Button>
                <V3Button variant="primary" size="md" onClick={this.confirmViewSwitch}>Continue</V3Button>
              </div>
            </div>
          </div>
        )}

        {this.renderSaveProfileModal()}
      </div>
    );
  }

  renderSaveProfileModal() {
    const { saveProfileOpen, saveProfileName, currentProfileId, currentProfileName } = this.state;
    const { profileSaving } = this.props;
    if (!saveProfileOpen) return null;
    const tags = this.buildProfilePreviewTags();
    const trimmedName = saveProfileName.trim();
    // Suppress the Save action while we have a project-level profile_id on
    // the variable dict but the userProfiles fetch hasn't resolved its title
    // yet — without this, a quick user could submit before hydration lands
    // and trigger the create path for what should have been an update,
    // duplicating the profile on the server.
    const vars = this.props.projectVariables || {};
    const varsProfileIdRaw = vars.profile_id;
    const varsProfileIdNum = varsProfileIdRaw !== null && varsProfileIdRaw !== undefined && varsProfileIdRaw !== ''
      ? Number(varsProfileIdRaw)
      : NaN;
    const profiles = Array.isArray(this.props.userProfiles) ? this.props.userProfiles : [];
    const varsProfileExists = profiles.some((p) => p && typeof p.id === 'number' && p.id === varsProfileIdNum);
    const hasUnresolvedProjectProfile = currentProfileId === null
      && varsProfileIdRaw !== null
      && varsProfileIdRaw !== undefined
      && varsProfileIdRaw !== ''
      && (!!this.props.userProfilesLoading || varsProfileExists);
    const disabled = !trimmedName || !!profileSaving || hasUnresolvedProjectProfile;
    const hasCurrent = currentProfileId !== null && currentProfileName !== null;
    let hint: { text: string; kind: 'update' | 'create' } | null = null;
    if (trimmedName.length > 0) {
      if (hasCurrent && trimmedName === currentProfileName) {
        hint = { text: 'This user profile will be updated!', kind: 'update' };
      } else {
        hint = { text: 'A new user profile will be created!', kind: 'create' };
      }
    }
    return (
      <div className="v3-save-prf-overlay" onClick={this.closeSaveProfile}>
        <div className="v3-save-prf-card" onClick={(e) => e.stopPropagation()}>
          <div className="v3-save-prf-hdr">
            <div className="v3-save-prf-title">Save as Profile</div>
            <button
              type="button"
              className="v3-modal-close"
              onClick={this.closeSaveProfile}
              aria-label="Close save profile dialog"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
              </svg>
            </button>
          </div>
          <div className="v3-save-prf-body">
            <p className="v3-save-prf-desc">
              This profile will save your system config so you can reuse it when creating new projects.
            </p>
            {tags.length > 0 && (
              <div className="v3-save-prf-preview">
                {tags.map((t, i) => (
                  <span key={`${t}-${i}`} className="v3-save-prf-tag">{t}</span>
                ))}
              </div>
            )}
            <div className="v3-modal-field" style={{ marginBottom: 0 }}>
              <label>Profile Name</label>
              <input
                className="v3-modal-input"
                type="text"
                placeholder="e.g. Standard Residential NXT"
                value={saveProfileName}
                onChange={this.onSaveProfileNameChange}
                onKeyDown={this.onSaveProfileKeyDown}
                autoFocus
              />
              {hint && (
                <div
                  className={`v3-save-prf-hint v3-save-prf-hint-${hint.kind}`}
                >
                  {hint.text}
                </div>
              )}
            </div>
          </div>
          <div className="v3-save-prf-ftr">
            <button
              type="button"
              className="v3-btn v3-btn-ghost"
              onClick={this.closeSaveProfile}
            >
              Cancel
            </button>
            <button
              type="button"
              className="v3-btn v3-btn-primary"
              onClick={this.confirmSaveProfile}
              disabled={disabled}
            >
              {profileSaving
                ? 'Saving…'
                : hasUnresolvedProjectProfile
                  ? 'Loading profile…'
                  : 'Save Profile'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(appState: any): ReduxProps {
  const envConfig = appState.projectConfiguration && appState.projectConfiguration.projectEnvConfig;
  const lite = appState.liteProject || {};
  return {
    lat: envConfig ? envConfig.lat : undefined,
    lng: envConfig ? envConfig.lng : undefined,
    zipcode: envConfig ? envConfig.zipcode : undefined,
    address: envConfig ? envConfig.client_address : undefined,
    advanceRoofSelecting: appState.advanceRoofSelecting,
    selectedRoofId: appState.background ? appState.background.selectedRoofId : null,
    backgroundCords: appState.background ? appState.background.cords : null,
    showArrayNumber: appState.background ? !!appState.background.showArrayNumber : false,
    moveArrayMode: appState.background ? !!appState.background.moveArrayMode : false,
    panels: appState.panels && Array.isArray(appState.panels.panels) ? appState.panels.panels : [],
    userProfiles: Array.isArray(lite.userProfiles) ? lite.userProfiles : [],
    userProfilesLoading: !!lite.userProfilesLoading,
    lastCreatedProfile: lite.lastCreatedProfile || null,
    profileSaving: !!lite.profileSaving,
    projectVariables: lite.projectVariables || {},
    domesticContent: !!(envConfig && envConfig.domestic_content),
    liteUpdating: !!lite.updating,
    liteDirty: !!(appState.app && appState.app.liteDirty),
    stageScale: appState.stage && appState.stage.stageScale ? appState.stage.stageScale : { x: 1, y: 1 },
  };
}

export default connect(mapStateToProps)(DesignWorkspace);
